import { Platform, StyleSheet } from 'react-native';
import { fontInPercentage, widthInPercentage } from '../../utils/appUtils';
import { responsiveHeight } from '../customResponsiveDimension';
export default StyleSheet.create({
  /*home page*/
  headingText: {
    justifyContent: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    fontFamily: 'Mulish, Helvetica Neue, Helvetica,Arial,sans-serif',
  },
  cardStyle: {
    borderColor: '#EE731B',
    margin: 15,
    marginTop: 25,
    width: 300,
    color: 'white',
    height: 250,
    alignSelf: 'center',
    borderRadius: 10,
  },
  cardStyle_MDPI: {
    borderColor: 'transparent',
    margin: 15,
    width: '80%',
    //  height: 240,
    color: 'white',
    alignSelf: 'center',
    borderRadius: 10,
  },
  cardStyle_LDPI: {
    borderColor: 'transparent',
    margin: 15,
    width: '80%',
    // height: 240,
    color: 'white',
    alignSelf: 'center',
    borderRadius: 10,
  },
  homecard_main_section: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: Platform.OS === 'web' ? '0%' : null,
    paddingBottom: Platform.OS === 'web' ? null : 70,
    justifyContent: 'center',
  },
  homecard_main_section_XXHDPI: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: Platform.OS === 'web' ? '0' : null,
  },
  homecard_main_section_XXHDPI: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: Platform.OS === 'web' ? '0' : null,
  },
  homecard_main_section_HDPI: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: Platform.OS === 'web' ? '0' : null,
  },
  homecard_main_section_MDPI: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: Platform.OS === 'web' ? '0' : null,
  },
  homecard_main_section_LDPI: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: Platform.OS === 'web' ? '0' : null,
  },
  homecard_container: {
    backgroundColor: 'white',
    height: '100%',
    // marginBottom:20
  },
  homecard_container_LDPI: {
    backgroundColor: 'white',
    height: '100%',
    // marginBottom:10
  },
  homecard_container_MDPI: {
    backgroundColor: 'white',
    height: '100%',
    //  marginBottom:10
  },
  homecard_card: {
    margin: 12,
    alignSelf: 'center',
    width: 100,
    height: 100,
  },
  homecard_card_HDPI: {
    margin: 12,
    alignSelf: 'center',
    width: 80,
    height: 80,
    borderRadius: 38,
  },
  homecard_card_MDPI: {
    margin: 12,
    alignSelf: 'center',
    width: 80,
    height: 80,
    borderRadius: 38,
  },
  homecard_card_LDPI: {
    margin: 12,
    alignSelf: 'center',
    width: 80,
    height: 80,
    borderRadius: 38,
  },
  homecard_image: {
    width: '60%',
    height: '100%',
    alignSelf: 'center',
    resizeMode: 'contain',
  },
  homecard_accnt_name: {
    fontWeight: 'normal',
    fontSize: 18,
    marginTop: 5,
  },
  homecard_apply_section: {
    backgroundColor: '#B02A31',
    borderRadius: 20,
    paddingVertical: 10,
    paddingHorizontal: 20,
    marginTop: 15,
    marginBottom: 30,
  },
  apply_now: {
    fontSize: 14,
    color: 'white',
    textAlign: 'center',
  },

  /*profileDetails*/
  maincontainer: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '66%',
    borderRadius: 10,
  },
  maincontainer_LDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    borderRadius: 8,
  },
  maincontainer_MDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    borderRadius: 8,
  },
  maincontainer_HDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    borderRadius: 8,
  },
  maincontainer_XHDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    borderRadius: 8,
  },
  maincontainerwidth: {
    width: '100%',
    marginTop: 10,
  },
  maincontainerwidth1: {
    // width: '100%',
    margin: 10,
    padding: 10,
  },
  maincontainerwidth1_LDPI: {
    // width: '100%',
    margin: 0,
    padding: 10,
  },
  maincontainerwidth1_MDPI: {
    // width: '100%',
    margin: 0,
    padding: 10,
  },
  maincontainerwidth1_HDPI: {
    // width: '100%',
    margin: 0,
    padding: 10,
  },
  inputMargins: {
    margin: 20,
    marginTop: 10,
  },
  inputMargins_LDPI: {
    margin: 10,
    marginTop: 10,
  },
  inputMargins_MDPI: {
    margin: 10,
    marginTop: 10,
  },
  AINumberOfDep: {
    width: '8%',
    marginLeft: 10,
    marginTop: 10,
    zIndex: -1,
    alignContent: 'center',
  },
  AINumberOfDep_LDPI: {
    width: '15%',
    marginLeft: 10,
    marginTop: 10,
    zIndex: -1,
    alignContent: 'center',
  },
  AINumberOfDep_MDPI: {
    width: '15%',
    marginLeft: 10,
    marginTop: 10,
    zIndex: -1,
    alignContent: 'center',
  },
  inputTexts: {
    color: 'black',
    marginLeft: 10,
    marginVertical: 5,
    fontWeight: '400',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontSize: 16,
  },
  inputsubTexts: {
    color: 'grey',
    fontSize: 14,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  inputTexts_LDPI: {
    color: 'black',
    marginLeft: 10,
    fontWeight: '400',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontSize: 14,
  },
  inputTexts_MDPI: {
    color: 'black',
    marginLeft: 10,
    fontWeight: '400',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontSize: 14,
  },
  inputTextsFatca: {
    color: 'black',
    marginLeft: 5,
    marginVertical: 5,
    fontWeight: '400',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontSize: 16,
  },
  inputTextsFatca_LDPI: {
    color: 'black',
    marginLeft: 5,
    fontWeight: '400',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontSize: 14,
  },
  inputTextsFatca_MDPI: {
    color: 'black',
    marginLeft: 5,
    fontWeight: '400',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontSize: 14,
  },
  NDmainContainer: {
    backgroundColor: 'white',
    //  zIndex: -9,
    alignSelf: 'center',
    width: '70%',
    borderRadius: 10,
  },
  NDFooterView: {
    marginBottom: 20,
    textAlign: 'right',
    marginHorizontal: 30,
    zIndex: -1,
  },
  NDFooterText: {
    fontSize: 14,
    color: 'red',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  NDmainContainer_LDPI: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '90%',
    borderRadius: 10,
  },
  NDmainContainer_MDPI: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '90%',
    borderRadius: 10,
  },

  NDmainContainerDirectorPage: {
    backgroundColor: 'white',
    //  zIndex: -9,
    alignSelf: 'center',
    width: '70%',
    borderRadius: 10,
  },
  NDmainContainerDirectorPage_LDPI: {
    backgroundColor: 'white',
    //  zIndex: -9,
    alignSelf: 'center',
    width: '95%',
    borderRadius: 10,
  },
  NDmainContainerDirectorPage_MDPI: {
    backgroundColor: 'white',
    //  zIndex: -9,
    alignSelf: 'center',
    width: '95%',
    borderRadius: 10,
  },
  NDmainContainerDirectorPage_HDPI: {
    backgroundColor: 'white',
    //  zIndex: -9,
    alignSelf: 'center',
    width: '95%',
    borderRadius: 10,
  },

  TextinputMainView: {
    margin: 20,
    marginTop: 10,
  },
  TextinputMainText: {
    color: 'black',
    marginLeft: 10,
    fontWeight: '500',
    fontSize: 16,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  NameCCMainView: {
    margin: 20,
    marginTop: 10,
  },
  NameCCMainText: {
    color: 'black',
    marginLeft: 10,
    fontWeight: '500',
    fontSize: 16,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  NDnomineeMainBtn1Text: {
    fontSize: 14,
    color: 'white',
    fontWeight: '700',
    textAlign: 'center',
    marginTop: 8,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  NDnomineeMainBtn2Text: {
    fontSize: 14,
    color: '#333',
    fontWeight: '700',
    textAlign: 'center',
    marginTop: 8,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  NDnomineeMainBtn1style: {
    shadowColor: '#d3d3d3',
    shadowOpacity: 1,
    shadowRadius: 10,
    borderColor: 'white',
    marginLeft: 150,
    margin: 6,
    borderWidth: 1,
    borderColor: 'white',
    elevation: 2,
    backgroundColor: '#B02A30',
    borderRadius: 0,
    height: 35,
    width: 140,
    marginTop: -25,
  },
  NDnomineeMainBtn1style_LDPI: {
    shadowColor: '#d3d3d3',
    shadowOpacity: 1,
    shadowRadius: 10,
    borderColor: 'white',
    marginLeft: 150,
    margin: 6,
    backgroundColor: '#B02A30',
    borderRadius: 0,
    height: 35,
    width: 100,
    marginTop: -25,
  },
  NDnomineeMainBtn1style_MDPI: {
    shadowColor: '#d3d3d3',
    shadowOpacity: 1,
    shadowRadius: 10,
    borderColor: 'white',
    marginLeft: 150,
    margin: 6,
    backgroundColor: '#B02A30',
    borderRadius: 0,
    height: 35,
    width: 100,
    marginTop: -25,
  },
  NDnomineeMainBtn2style: {
    shadowColor: '#d3d3d3',
    shadowOpacity: 1,
    shadowRadius: 10,
    borderColor: 'white',
    marginLeft: 150,
    margin: 6,
    borderWidth: 1,
    borderColor: 'white',
    elevation: 2,
    backgroundColor: 'white',
    borderRadius: 0,
    height: 35,
    width: 140,
    marginTop: -25,
  },
  NDnomineeMainBtn2style_MDPI: {
    shadowColor: '#d3d3d3',
    shadowOpacity: 1,
    shadowRadius: 10,
    borderColor: 'white',
    marginLeft: 150,
    margin: 6,
    backgroundColor: 'white',
    borderRadius: 0,
    height: 35,
    width: 100,
    marginTop: -25,
  },
  NDnomineeMainBtn2style_LDPI: {
    shadowColor: '#d3d3d3',
    shadowOpacity: 1,
    shadowRadius: 10,
    borderColor: 'white',
    marginLeft: 150,
    margin: 6,
    backgroundColor: 'white',
    borderRadius: 0,
    height: 35,
    width: 100,
    marginTop: -25,
  },
  NDnomineeView: {
    margin: 20,
    marginTop: 10,
    zIndex: -9,
  },
  NDnomineeText: {
    color: 'black',
    marginLeft: 10,
    fontWeight: '500',
    fontSize: 16,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  NDsecondContainer: {
    width: '100%',
    marginTop: 10,
  },
  NDinnerContainerItem: {
    margin: 20,
    marginTop: 10,
  },
  NDinnerItemText: {
    color: 'black',
    marginLeft: 10,
    fontWeight: '500',
    fontSize: 16,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  NDinnerItemTextParental: {
    color: 'black',
    marginLeft: 10,
    fontWeight: '500',
    fontSize: 16,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  NDinnerItemTextParental_LDPI: {
    color: 'black',
    marginLeft: 10,
    fontWeight: '500',
    fontSize: 13,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  NDDatepickerView: {
    marginTop: 10,
    marginRight: 0,
    //  width: '-webkit-fill-available'
  },
  NDDatepickerError: {
    color: 'red',
    margin: 5,
    marginLeft: 10,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  NDradioBtnMainView: {
    margin: 20,
    marginTop: 20,
    zIndex: -9,
    // flexDirection:"row"
  },
  NDradioBtnMainView_LDPI: {
    margin: 20,
    marginTop: 20,
    zIndex: -9,
    //  flexDirection:"row"
  },
  NDradioBtnMainView_MDPI: {
    margin: 20,
    marginTop: 20,
    zIndex: -9,
    //  flexDirection:"row"
  },
  NDradioBtnMainText: {
    color: 'black',
    marginLeft: 10,
    fontWeight: '500',
    fontSize: 16,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  NDradioBtnView: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 20,
  },
  NDradioBtnView_XXHDPI: {
    flexDirection: 'column',
    marginTop: 10,
  },
  NDradioBtnView_XHDPI: {
    marginTop: 10,
    flexDirection: 'column',
  },
  NDradioBtnView_HDPI: {
    marginTop: 10,
    flexDirection: 'column',
  },
  NDradioBtnView_LDPI: {
    flexDirection: 'column',
    marginTop: 10,
  },
  NDradioBtnView_MDPI: {
    flexDirection: 'column',
    marginTop: 10,
  },
  NDradioBtnstyle1: {
    // flex: 0.33,
    margin: 6,
    shadowColor: '#d3d3d3',
    shadowOpacity: 1,
    shadowRadius: 10,
    borderWidth: 1,
    borderColor: 'white',
    borderRadius: 0,
    height: 35,
    width: 200,
    elevation: 2,
    //  marginTop: -25,
  },
  NDradioBtnstyle1_LDPI: {
    height: 45,
  },
  NDradioBtnstyle1_MDPI: {
    height: 45,
  },
  NDradioBtnTextstyle1: {
    fontSize: 12,
    color: '#333',
    fontWeight: '700',
    textAlign: 'center',
    marginTop: 8,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  NDradioBtnstyle2: {
    // flex: 0.33,
    shadowColor: '#d3d3d3',
    shadowOpacity: 1,
    shadowRadius: 10,
    margin: 6,
    backgroundColor: '#B02A30',
    borderRadius: 0,
    borderWidth: 1,
    borderColor: 'white',
    height: 35,
    width: 200,
    elevation: 2,
    //  marginTop: -25,
  },
  NDradioBtnstyle2_LDPI: {
    height: 45,
  },
  NDradioBtnstyle2_MDPI: {
    height: 45,
  },
  NDradioBtnstyle3: {
    // flex: 0.33,
    margin: 6,
    elevation: 2,
    shadowColor: '#d3d3d3',
    shadowOpacity: 1,
    shadowRadius: 10,
    backgroundColor: 'white',
    borderColor: 'white',
    borderRadius: 0,
    borderWidth: 1,
    borderColor: 'white',
    height: 35,
    width: 200,
    //  marginTop: -25,
  },
  NDradioBtnstyle3_LDPI: {
    height: 45,
  },
  NDradioBtnstyle3_MDPI: {
    height: 45,
  },
  NDradioBtnstyle4: {
    // flex: 0.33,
    shadowColor: '#d3d3d3',
    shadowOpacity: 1,
    elevation: 2,
    shadowRadius: 10,
    borderWidth: 1,
    borderColor: 'white',
    margin: 6,
    backgroundColor: '#B02A30',
    borderRadius: 0,
    height: 35,
    width: 200,
    // marginTop: -25,
  },
  NDradioBtnstyle4_LDPI: {
    height: 45,
  },
  NDradioBtnstyle4_MDPI: {
    height: 45,
  },
  NDradioBtnText2style1: {
    fontWeight: '500',
    textAlign: 'center',
    marginTop: 8,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  NDradioBtnTextstyle2: {
    color: 'white',
    fontWeight: '700',
    textAlign: 'center',
    marginTop: 8,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },

  TCmainContainer: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '70%',
    padding: 30,
    paddingTop: 40,
    borderRadius: 10,
  },
  TCCheckboxbtn1Text: {
    fontSize: 12,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    color: '#505050',
    paddingTop: 5,
    marginLeft: 10,
  },
  TCCheckboxbtn1: {
    width: '100%',
    paddingLeft: 2,
  },
  TCCheckboxInnerView: {
    flexDirection: 'row',
    marginTop: 10,
  },
  TCCheckboxView: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  TCBtnView: {
    marginTop: 20,
    marginBottom: 10,
    marginLeft: 5,
    alignItems: 'center',
  },
  TCBtnText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#6f6363',
  },
  TCmainContainer_LDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    padding: 30,
    paddingTop: 40,
    borderRadius: 10,
  },
  TCmainContainer_MDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    padding: 30,
    paddingTop: 40,
    borderRadius: 10,
  },
  TCheading1View: {
    marginTop: 15,
    marginBottom: 15,
  },
  TCheading1Text: {
    fontSize: 14,
    fontWeight: '700',
    //color: '#6f6363',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    textDecorationLine: 'underline',
  },
  TCheading2View: {
    marginTop: 15,
    marginBottom: 15,
  },
  TCheading2Text: {
    fontSize: 13,
    color: '#999',
    lineHeight: 20,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  TCheading3TextCurrent: {
    fontSize: 13,
    marginTop: 10,
    color: 'rgb(153, 153, 153)',
    fontWeight: '500',
    lineHeight: 20,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  TCheading3Text: {
    fontSize: 13,
    marginTop: 10,
    color: '#999',
    lineHeight: 20,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  TCText1: {
    fontSize: 14,
    fontWeight: '600',
    color: '#6f6363',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  TCText2: {
    fontSize: 13,
    lineHeight: 20,
    color: '#999',
    // marginLeft: 5,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  TCText2current: {
    fontWeight: '500',
    fontSize: 13,
    lineHeight: 20,
    color: 'rgb(153, 153, 153)',
    marginLeft: 5,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  TCText2NewIC: {
    fontSize: 13,
    lineHeight: 20,
    color: '#0000ff',
    marginLeft: 5,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  TCText2NewIB: {
    fontSize: 13,
    lineHeight: 20,
    color: '#999',
    marginLeft: 5,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  TCMargin: {
    marginTop: 10,
  },
  TCText3: {
    fontSize: 14,
    lineHeight: 20,
    fontWeight: '600',
    color: '#6f6363',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  TCText4: {
    fontSize: 14,
    fontWeight: '600',
    color: '#6f6363',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  OVmainContainer: {
    position: Platform.OS === 'web' ? 'fixed' : 'absolute',
    minHeight: 'auto',
    zIndex: 9,
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    left: 0,
    right: 0,
    marginTop: 'auto',
    marginBottom: 'auto',
    top: 0,
    bottom: 0,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    borderColor: 'transparent',
    borderWidth: 1,
    borderRadius: 8,
  },
  OVtimerView: {
    marginTop: 5,
  },
  OVOtpResendView: {
    marginTop: 10,
  },
  OVOtpResendText: {
    color: '#B02A30',
    textDecorationLine: 'underline',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontWeight: '600',
  },
  OVpinInputerrorText: {
    color: 'red',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },

  OVpinInputsecView: {
    // flexDirection: 'row',
    marginTop: 20,
    width: '50%',
    alignSelf: 'flex-start',
  },
  OVpinInputsecView_LDPI: {
    // flexDirection: 'row',
    marginTop: 20,
    width: '100%',
  },
  OVpinInputsecView_MDPI: {
    // flexDirection: 'row',
    marginTop: 20,
    width: '100%',
  },
  OVContinuebtnView: {
    marginTop: 10,
  },
  OVpinInputMainView: {
    // flexDirection:"row",
    width: '100%',
    display: Platform.OS === 'web' ? 'inline-block' : null,
  },

  OVContinuebtn: {
    backgroundColor: '#B02A31',
    borderRadius: 20,
    height: 35,
    width: 150,
    marginBottom: 20,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
  OVContinuebtnText: {
    fontSize: 12,
    fontWeight: '500',
    textAlign: 'center',
    color: 'white',
  },
  OVmainTextView: {
    marginBottom: 10,
    // flex: 1
  },
  OVmainBtnView: {
    flex: 1,
  },
  OVOtpText: {
    fontSize: 12,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },

  OVclosebtnStyle: {
    borderRadius: 0,
    alignSelf: 'flex-end',
  },
  OVmainTextMainView: {
    flexDirection: 'row',
  },
  verif: {
    width: 100,
    height: 100,
    alignSelf: 'flex-end',
    marginTop: '2%',
    marginLeft: '35%',
  },
  OVTimerText: {
    fontSize: 12,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontWeight: '600',
  },
  OVsubContainer: {
    backgroundColor: 'white',
    borderWidth: 1,
    width: '60%',
  },
  OVsubContainer_LDPI: {
    backgroundColor: 'white',
    borderWidth: 1,
    width: '100%',
  },
  OVsubContainer_MDPI: {
    backgroundColor: 'white',
    borderWidth: 1,
    width: '100%',
  },
  OVsubContainer1: {
    padding: 20,
  },
  panverified_LDPI: {
    bottom: 0,
    width: '100%',
    marginTop: 10,
  },
  panverified_MDPI: {
    bottom: 0,
    width: '100%',
    marginTop: 10,
  },
  OVmainText1: {
    fontSize: 18,
    fontWeight: '500',
    textAlign: 'center',
    color: 'black',
    marginTop: -2,
  },
  OVmainText: {
    fontSize: 16,
    fontWeight: '600',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  OVOtpTextView: {
    marginBottom: 5,
  },
  blackoutstyle: {
    zIndex: 10,
    opacity: 0.2,
  },
  blackoutView: {
    padding: 20,
  },
  blackoutmain: {
    zIndex: 9,
    position: Platform.OS === 'web' ? 'fixed' : 'absolute',
    width: '100%',
    left: 0,
    right: 0,
    marginTop: 'auto',
    marginBottom: 'auto',
    top: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
    borderColor: 'transparent',
    borderWidth: 1,
  },

  bootboxcontainer: {
    position: Platform.OS === 'web' ? 'fixed' : 'absolute',
    minHeight: 'auto',
    zIndex: 9,
    marginLeft: 'auto',
    marginRight: 'auto',
    left: 0,
    right: 0,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    borderColor: 'transparent',
    borderWidth: 1,
  },
  bootboxtextView: {
    padding: 20,
  },
  bootboxtextView_LDPI: {
    padding: 5,
  },
  bootboxMainbox: {
    backgroundColor: 'white',
    width: '40%',
    borderRadius: 10,
    marginTop: 10,
  },
  bootboxMainbox_LDPI: {
    backgroundColor: 'white',
    width: '80%',
    borderRadius: 10,
  },
  bootboxMainbox_MDPI: {
    backgroundColor: 'white',
    width: '80%',
    borderRadius: 10,
  },
  bootboxMainbox_HDPI: {
    backgroundColor: 'white',
    width: '80%',
    borderRadius: 10,
  },
  bootboxMainbox_XHDPI: {
    backgroundColor: 'white',
    width: '60%',
    borderRadius: 10,
  },
  bootboxbtn: {
    borderRadius: 20,
    // height: 20,
    // width: 50,
    alignSelf: 'flex-end',
    marginTop: 10,
    marginRight: 15,
  },
  bootboxbtnText: {
    fontSize: 16,
    fontWeight: '500',
    textAlign: 'center',
    color: 'grey',
  },
  bootboxtext: {
    fontSize: 14,
    lineHeight: 20,
    color: '#333',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  bootboxborderline: {
    borderTopWidth: 1,
    borderTopColor: '#e5e5e5',
    alignItems: 'center',
    justifyContent: 'center',
  },
  bootboxbtn2: {
    height: 40,
    width: 60,
    borderRadius: 50,
    alignSelf: 'flex-end',
    backgroundColor: '#337ab7',
    justifyContent: 'center',
    alignItems: 'center',
  },
  bootboxbtn22: {
    height: 40,
    padding: 10,
    borderRadius: 10,
    alignSelf: 'flex-end',
    backgroundColor: 'maroon',
    justifyContent: 'center',
    alignItems: 'center',
  },
  bootboxtext1: {
    fontSize: 14,
    fontWeight: '400',
    textAlign: 'center',
    color: 'white',
  },
  bootbox1Mainbox: {
    backgroundColor: 'white',
    width: '80%',
    height: 150,
    borderRadius: 10,
  },



  CLICarDetilsFlexViewMainone: {
    flexDirection: 'row',
    flex: 1,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
  },
  CLICarDetilsFlexViewMainone_LDPI: {
    flexDirection: 'column',
    flex: 1,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
  },
  CLICarDetilsFlexViewMainone_MDPI: {
    flexDirection: 'column',
    flex: 1,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
  },
  CLICarDetilsFlexViewMainone_HDPI: {
    flexDirection: 'column',
    flex: 1,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
  },
  CLICarDetilsFlexViewMainone_XHDPI: {
    flexDirection: 'column',
    flex: 1,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
  },
  CLICarDetilsFlexViewMaintwo: {
    flexDirection: 'row',
    flex: 1,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
  },
  CLICarDetilsFlexViewMaintwo_LDPI: {
    flexDirection: 'column',
    flex: 1,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
  },
  CLICarDetilsFlexViewMaintwo_MDPI: {
    flexDirection: 'column',
    flex: 1,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
  },
  CLICarDetilsFlexViewMaintwo_HDPI: {
    flexDirection: 'column',
    flex: 1,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
  },
  CLICarDetilsFlexViewMaintwo_XHDPI: {
    flexDirection: 'column',
    flex: 1,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
  },
  radiobtnText: {
    fontSize: 14,
    color: '#333',
    fontWeight: '600',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    textAlign: 'center',
    marginTop: 8,
  },
  radiobtnTextselect: {
    fontSize: 14,
    color: 'white',
    fontWeight: '600',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    textAlign: 'center',
    marginTop: 8,
  },
  subradiobtnView: {
    backgroundColor: 'white',
    marginTop: 5,
    borderWidth: 1,
    padding: 10,
    borderColor: 'white',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.2,
    shadowRadius: 4.0,

    elevation: 2,
  },
  loadermain: {
    position: 'absolute',
    minHeight: 'auto',
    zIndex: 10,
    height: '100%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    backgroundColor: 'rgba(0,0,0,.8)',
    borderColor: 'transparent',
    borderWidth: 1,
  },
  modelStyle11: {
    position: Platform.OS === 'web' ? 'fixed' : 'absolute',
    minHeight: 'auto',
    zIndex: 9,
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    left: 0,
    right: 0,
    marginTop: 'auto',
    marginBottom: 'auto',
    top: 0,
    bottom: 0,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    borderColor: 'transparent',
  },

  loadingView: {
    padding: 20,
  },
  spinnerStyle: {
    zIndex: 99,
  },
  buttonContainer: {
    margin: '3%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '50%',
  },
  AMCstatusbtnText: {
    fontSize: 12,
    fontWeight: '600',
    color: 'blue',
    textDecorationLine: 'underline',
  },
  AMCstatusbtnView: {
    marginTop: 20,
    marginBottom: 10,
    marginLeft: 5,
  },
  AMCinstructions2Text: {
    color: 'black',
    marginRight: 8,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  AMCinstructionsText: {
    fontSize: 13,
    color: '#333333',
    marginLeft: 8,
    lineHeight: 23,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  buttonStyle: {
    margin: 10,
  },
  AMCinstrText: {
    fontSize: 14,
    color: 'black',
    // marginLeft: 10,
    fontWeight: 'bold',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  AMCinstrView: {
    marginTop: 25,
    marginBottom: 5,
  },
  AMCsecBtn2View: {
    // right: 0,
    // position: Platform.OS === 'web' ? 'initial' : 'relative',
  },
  AMCsecBtn2style: {
    width: '15%',
    position: 'absolute',
    right: 0,
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginRight: 5,
    height: 35,
    marginBottom: 20,
    alignSelf: 'flex-start',
  },
  AMCsecBtn2style_LDPI: {
    width: '30%',
    position: 'absolute',
    right: 0,
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginRight: 5,
    height: 35,
    marginBottom: 20,
  },
  AMCsecBtn2style_MDPI: {
    width: '30%',
    position: 'absolute',
    right: 0,
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginRight: 5,
    height: 35,
    marginBottom: 20,
  },

  AMCsecBtn2styleNew: {
    // position: 'absolute',
    right: 0,
    paddingVertical: 10,
    paddingHorizontal: 35,
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginRight: 5,
    marginBottom: 20,
    alignSelf: 'flex-end',
    borderRadius: 6,
  },
  AMCsecBtn2styleNew_LDPI: {
    // position: 'absolute',
    right: 0,
    paddingHorizontal: 20,
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginRight: 5,
    marginBottom: 20,
  },
  AMCsecBtn2styleNew_MDPI: {
    // position: 'absolute',
    right: 0,
    paddingHorizontal: 20,
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginRight: 5,
    marginBottom: 20,
  },
  AMCsecBtnstyle: {
    width: '20%',
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginLeft: 8,
    marginRight: 5,
    height: 35,
    marginBottom: 20,
  },
  AMCsecBtnstyle_LDPI: {
    width: '40%',
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginLeft: 8,
    marginRight: 5,
    height: 35,
    marginBottom: 20,
  },
  AMCsecBtnstyle_MDPI: {
    width: '40%',
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginLeft: 8,
    marginRight: 5,
    height: 35,
    marginBottom: 20,
  },
  AMCsecBtnstyleNew: {
    // width: '17%',
    paddingVertical: 10,
    paddingHorizontal: 15,
    backgroundColor: '#B02A31',
    borderColor: 'white',
    // marginLeft: 8,
    marginRight: 5,
    marginBottom: 20,
    borderRadius: 6,
  },
  AMCsecBtnstyleNew_LDPI: {
    // width: '40%',
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginRight: 5,
    marginBottom: 20,
    borderRadius: 6,
  },
  AMCsecBtnstyleNew_MDPI: {
    // width: '40%',
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginRight: 5,
    marginBottom: 20,
    borderRadius: 6,
  },

  AMCsecBtnstyle_LDPI: {
    width: '40%',
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginRight: 5,
    height: 35,
    marginBottom: 20,
  },
  AMCsecBtnstyle_MDPI: {
    width: '40%',
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginRight: 5,
    height: 35,
    marginBottom: 20,
  },
  AMCsecBtnView: {
    flexDirection: 'row',
    marginTop: 10,
  },
  AMCsecBtnViewNew: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  AMCLimitText: {
    fontSize: 14,
    color: '#6f6363',
    // marginLeft: 8,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  AMCbtnText: {
    fontSize: 14,
    fontWeight: '600',
    textAlign: 'center',
    width: '100%',
    height: '100%',
    padding: 7,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  AMCbtnText_LDPI: {
    fontSize: 13,
    padding: 6,
  },
  AMCbtnText_MDPI: {
    fontSize: 13,
    padding: 6,
  },
  AMCbtnText_HDPI: {
    fontSize: 13,
    padding: 6,
  },
  AMCmaincontainer: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '75%',
    paddingVertical: 30,
    paddingHorizontal: 40,
    borderRadius: 10,
  },
  AMCmaincontainer_LDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    paddingVertical: 10,
    paddingHorizontal: 15,
    borderRadius: 10,
  },
  AMCmaincontainer_MDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    paddingVertical: 10,
    paddingHorizontal: 15,
    borderRadius: 10,
  },
  AMCmaincontainer_HDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    paddingVertical: 10,
    paddingHorizontal: 15,
    borderRadius: 10,
  },
  AMCmainTextView: {
    marginVertical: 10,
  },
  AMCmainTextstyle: {
    fontSize: 14,
    fontWeight: '100',
    color: '#000',
    // fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  AMCinputboxView: {
    flexDirection: 'row',
  },
  AMCinputboxText: {
    fontSize: 14,
    marginTop: 10,
    // marginLeft: 10,
    fontWeight: '400',
    color: 'red',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  AMCbtnView: {
    flexDirection: 'row',
    marginTop: 10,
    // width: '60%',
    flexWrap: 'wrap',
    // alignItems:'center',
    // justifyContent:'center'
  },
  // AMCbtnView_LDPI: {
  //   flexDirection: 'row',
  //   marginTop: 10,
  //   width: '100%',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  //   marginLeft: 'auto',
  //   marginRight: 'auto',
  // },
  // AMCbtnView_MDPI: {
  //   flexDirection: 'row',
  //   marginTop: 10,
  //   width: '100%',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  //   marginLeft: 'auto',
  //   marginRight: 'auto',
  // },
  AMCbtnstyle: {
    borderWidth: 1,
    marginLeft: 8,
    marginRight: 5,
    width: 100,
    marginBottom: 20,
  },
  AMCbtnstyle_LDPI: {
    width: 80,
    borderWidth: 1,
    marginLeft: 8,
    marginRight: 5,
  },
  AMCbtnstyle_MDPI: {
    width: 80,
    borderWidth: 1,
    marginLeft: 8,
    marginRight: 5,
  },
  AMCbtnstyle_HDPI: {
    width: 80,
    borderWidth: 1,
    marginLeft: 8,
    marginRight: 5,
  },
  AMCsecBtnText: {
    fontSize: 14,
    color: '#696969',
    fontWeight: '500',
    textAlign: 'center',
    color: 'white',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  AMCsecBtnTextFund: {
    fontSize: 14,
    color: '#696969',
    fontWeight: '500',
    textAlign: 'center',

    color: 'white',
    marginTop: 8,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  AMCsecBtnTextNew: {
    fontSize: 14,
    color: '#696969',
    fontWeight: '500',
    textAlign: 'center',
    color: 'white',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  plsIgnoreText: {
    marginTop: 0,
    marginBottom: 10,
    fontSize: 12,
    color: '#333333',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  AMCcontinueBtnView: {
    marginTop: 20,
    marginLeft: 350,
    // marginRight:'auto',
    width: '70%',
    // justifyContent:'center',
    // alignItems:'center'
    // alignSelf:'center'
    //alignContent:'center'
  },

  //AMCV

  AMCVstatusbtnText: {
    fontSize: 12,
    fontWeight: '600',
    color: 'blue',
    textDecorationLine: 'underline',
  },
  AMCVstatusbtnView: {
    marginTop: 20,
    marginBottom: 10,
    marginLeft: 5,
  },
  AMCVinstructions2Text: {
    color: 'black',
    marginRight: 8,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  AMCVinstructionsText: {
    fontSize: 13,
    color: '#6f6363',
    marginLeft: 8,
    lineHeight: 23,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  // buttonStyle: {
  //   margin: 10,
  // },
  AMCVinstrText: {
    fontSize: 22,
    color: 'black',
    marginLeft: 10,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  AMCVinstrView: {
    marginTop: 10,
    marginBottom: 5,
  },
  AMCVsecBtn2View: {
    // right: 0,
    // position: Platform.OS === 'web' ? 'initial' : 'relative',
  },
  AMCVsecBtn2style: {
    width: '15%',
    position: 'absolute',
    right: 0,
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginRight: 5,
    height: 35,
    marginBottom: 20,
    alignSelf: 'flex-start',
  },
  AMCVsecBtn2style_LDPI: {
    width: '30%',
    position: 'absolute',
    right: 0,
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginRight: 5,
    height: 35,
    marginBottom: 20,
  },
  AMCVsecBtn2style_MDPI: {
    width: '30%',
    position: 'absolute',
    right: 0,
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginRight: 5,
    height: 35,
    marginBottom: 20,
  },
  AMCVsecBtnstyle: {
    width: '20%',
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginLeft: 8,
    marginRight: 5,
    height: 35,
    marginBottom: 20,
  },
  AMCVsecBtnstyle_LDPI: {
    width: '40%',
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginLeft: 8,
    marginRight: 5,
    height: 35,
    marginBottom: 20,
  },
  AMCVsecBtnstyle_MDPI: {
    width: '40%',
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginLeft: 8,
    marginRight: 5,
    height: 35,
    marginBottom: 20,
  },

  AMCVsecBtnstyle_LDPI: {
    width: '40%',
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginLeft: 8,
    marginRight: 5,
    height: 35,
    marginBottom: 20,
  },
  AMCVsecBtnstyle_MDPI: {
    width: '40%',
    backgroundColor: '#B02A31',
    borderColor: 'white',
    marginLeft: 8,
    marginRight: 5,
    height: 35,
    marginBottom: 20,
  },
  AMCVsecBtnView: {
    flexDirection: 'row',
    marginTop: 10,
  },
  AMCVLimitText: {
    fontSize: 14,
    color: '#6f6363',
    marginLeft: 8,
    marginTop: 10,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  AMCVbtnText: {
    fontSize: 14,
    fontWeight: '500',
    textAlign: 'center',
    width: '100%',
    height: '100%',
    padding: 10,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  AMCVbtnText_LDPI: {
    fontSize: 11,
    fontWeight: '500',
    textAlign: 'center',
    width: '100%',
    height: '100%',
    padding: 5,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  AMCVbtnText_MDPI: {
    fontSize: 11,
    fontWeight: '500',
    textAlign: 'center',
    width: '100%',
    height: '100%',
    padding: 5,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  AMCVmaincontainer: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '75%',
    padding: 30,
  },
  AMCVmaincontainer_LDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    padding: 10,
    borderRadius: 10,
  },
  AMCVmaincontainer_MDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    padding: 10,
    borderRadius: 10,
  },
  AMCVmainTextView: {
    marginTop: 15,
    marginBottom: 15,
  },
  AMCVmainTextstyle: {
    fontSize: 14,
    fontWeight: '700',
    color: '#6f6363',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  AMCVinputboxView: {
    flexDirection: 'row',
  },
  AMCVinputboxText: {
    fontSize: 14,
    marginTop: 10,
    marginLeft: 10,
    fontWeight: '400',
    color: 'red',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  AMCVbtnView: {
    flexDirection: 'row',
    marginTop: 10,
    width: '60%',
    // alignItems:'center',
    // justifyContent:'center'
  },
  AMCVbtnView_LDPI: {
    flexDirection: 'row',
    marginTop: 10,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  AMCVbtnView_MDPI: {
    flexDirection: 'row',
    marginTop: 10,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  AMCVbtnstyle: {
    width: 40,
    borderWidth: 1,
    marginLeft: 8,
    marginRight: 5,
    height: 35,
    width: 100,
    marginBottom: 20,
  },
  AMCVbtnstyle_LDPI: {
    width: 65,
    borderWidth: 1,
    marginLeft: 8,
    marginRight: 5,
    height: 35,
    marginBottom: 20,
  },
  AMCVbtnstyle_MDPI: {
    width: 65,
    borderWidth: 1,
    marginLeft: 8,
    marginRight: 5,
    height: 35,
    marginBottom: 20,
  },
  AMCVsecBtnText: {
    fontSize: 14,
    color: '#696969',
    fontWeight: '500',
    textAlign: 'center',
    color: 'white',
    marginTop: 8,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },

  RCmaincontainer: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '70%',
    padding: 20,
    borderRadius: 10,
  },
  RCmaincontainer_LDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    padding: 10,
    borderRadius: 10,
  },
  RCmaincontainer_MDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    padding: 10,
    borderRadius: 10,
  },
  RCinputTitleMargin: {
    // paddingLeft: 20,
  },
  RCinputTitleinnerMargin: {
    marginTop: 2,
    marginBottom: 2,
  },
  RCproductDetailstitleText2: {
    color: 'black',
    marginRight: 8,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    textTransform: 'uppercase',
  },
  RCproductDetailstitleText: {
    fontWeight: '600',
    fontSize: 14,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  RCproductDetailsVIew: {
    width: '100%',
    marginTop: 0,
  },
  RCproductDetailstitleView: {
    paddingLeft: 20,
    marginBottom: 10,
  },
  RCinputTitleText: {
    fontSize: 16,
    color: '#333',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  RCinputTitleText_LDPI: {
    fontSize: 14,
    color: '#333',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  RCinputTitleText_MDPI: {
    fontSize: 14,
    color: '#333',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  RCinputTitleText_HDPI: {
    fontSize: 14,
    color: '#333',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },

  CLIrupeesymbolText: {
    fontSize: 16,
    alignSelf: 'center',
    fontFamily: 'Mulish',
  },

  CLIcalculateBtnstyle: {
    width: 150,
    padding: 8,
    backgroundColor: '#053c6d',
    paddingLeft: 12,
    paddingRight: 12,
  },
  CLIcalculateBtnText: {
    alignSelf: 'center',
    color: 'white',
    fontSize: 14,
    fontWeight: 'bold',
    fontFamily: 'Mulish',
  },
  RCinputTitleText11: {
    marginTop: 5,
    fontWeight: '700',
    marginBottom: 5,
    marginTop: 4,
    fontSize: 16,
    color: '#333',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  RCinputTitleText11_LDPI: {
    fontSize: 14,
    color: '#333',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  RCinputTitleText11_MDPI: {
    fontSize: 14,
    color: '#333',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  RCinputTitleText11_HDPI: {
    fontSize: 14,
    color: '#333',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },

  SLIMobileHoverBtnstyle: {
    width: 15,
    height: 15,
    marginLeft: 5,
  },
  SLIMobileHoverBtnImagestyle: {
    width: 15,
    height: 15,
  },
  SLIHoverableMainTextView: {
    height: '100%',
    justifyContent: 'center',
  },
  SLIHoverableMainView: {
    height: 20,
    width: 20,
    backgroundColor: 'transparent',
    margin: 0,
    alignSelf: 'center',
  },

  SLIinputPaddingView: {
    padding: 10,
  },

  eSignagrrMainViewstyle: {
    alignSelf: 'center',
  },
  eSignagrrMainViewstyle_XHDPI: {
    alignSelf: 'flex-start',
  },
  eSignagrrMainViewstyle_HDPI: {
    alignSelf: 'flex-start',
  },

  ESignAgree: {
    fontSize: 14,
    fontFamily: 'Mulish,Arial,Helvetica,sans-serif',
  },
  ESignAgree1: {
    fontSize: 14,
    fontFamily: 'Mulish,Arial,Helvetica,sans-serif',
  },
  ESignAgree1_MDPI: {
    fontSize: 14,
    width: '95%',
    fontFamily: 'Mulish,Arial,Helvetica,sans-serif',
  },
  RCUservalueText: {
    fontSize: 16,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  RCinputView: {
    marginBottom: 2,
    marginTop: 5,
  },
  RCinputMainView: {
    // paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 20,
  },
  RCinputscreenDivide: {
    width: '50%',
    marginTop: 0,
  },
  RCinputscreenDivide_LDPI: {
    width: '100%',
    marginTop: 0,
  },
  RCinputscreenDivide_MDPI: {
    width: '100%',
    marginTop: 0,
  },
  RCinputscreenDivide_HDPI: {
    width: '100%',
    marginTop: 0,
  },
  RCinputscreenDivide_XHDPI: {
    width: '100%',
    marginTop: 0,
  },
  RCinputscreenDivide_XXHDPI: {
    width: '100%',
    marginTop: 0,
  },
  RCinputscreenDivide_XXXHDPI: {
    width: '100%',
    marginTop: 0,
  },
  RCinputsheading: {
    fontSize: 16,
    fontWeight: '700',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    marginTop: 10,
  },
  RCimageStyle: {
    width: 15,
    height: 15,
    alignSelf: 'center',
    resizeMode: 'contain',
  },
  RCMarginView: {
    margin: 20,
  },
  RCinnerMarginView: {
    marginTop: 10,
    marginBottom: 10,
  },
  RCeditBtnView: {
    position: 'absolute',
    top: 0,
    right: 20,
  },
  RCflexScreen: {
    flexDirection: 'row',
  },
  RCflexScreen_LDPI: {
    flexDirection: 'column',
  },
  RCflexScreen_MDPI: {
    flexDirection: 'column',
  },
  RCeditBtnStyle: {
    resizeMode: 'contain',
    // width: 40,
    // height: 40,
  },
  RCcheckboxView: {
    display: Platform.OS === 'web' ? 'inline' : 'flex',
    marginVertical: 10,
  },
  RCmainWidth: {
    width: '100%',
  },
  RCaddressDetailsView: {
    width: '100%',
  },

  ageMargin: {
    margin: 20,
    marginTop: 10,
  },
  ageMargin_LAPTOP: {
    margin: 30,
    marginTop: 10,
  },

  ageheading: {
    color: 'black',
    fontWeight: '400',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontSize: 16,
  },

  ageheading2: {
    color: 'black',
    fontWeight: '400',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontSize: 16,
  },

  ageerror: {
    color: 'red',
    margin: 5,
    marginLeft: 5,
  },

  ageInputbox: {
    // marginHorizontal: 10,
    color: 'black',
    borderColor: 'transparent',
    borderBottomColor: '#dadada',
    borderWidth: 0.5,
    paddingTop: 10,
    paddingBottom: 5,
  },
  ageInputboxReference: {
    // marginHorizontal: 10,
    color: 'black',
    borderColor: 'transparent',
    borderBottomColor: '#FF6130',
    borderWidth: 0.5,
    paddingTop: 10,
    paddingBottom: 5,
  },
  ageInputboxReferenceCode: {
    // marginHorizontal: 10,
    color: 'black',
    borderColor: 'transparent',
    // borderBottomColor: '#FF6130',
    borderBottomColor: 'grey',
    borderWidth: 0.5,
    paddingTop: 10,
    paddingBottom: 5,
    textTransform: 'uppercase',
  },
  mainconatinerBtnmargins: {
    margin: 20,
    marginTop: 0,
    marginBottom: 0,
  },
  Textboxmargin: {
    margin: 40,
    marginTop: 10,
  },
  Text_inputText: {
    color: 'black',
    marginTop: -20,
    marginLeft: 10,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontWeight: '400',
  },
  ADmainContainer: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '70%',
    borderRadius: 10,
  },
  ADmainContainer_LDPI: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '90%',
    borderRadius: 10,
  },
  ADmainContainer_MDPI: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '90%',
    borderRadius: 10,
  },
  ADsecMainContainer: {
    width: '100%',
    marginTop: 10,
  },
  ADcheckboxText: {
    zIndex: -9,
    fontSize: 14,
    marginTop: 10,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  ADcheckboxMainView: {
    flexDirection: 'row',
  },
  ADDropdownsecView: {
    paddingLeft: 8,
  },
  ADDropdown2View: {
    margin: 20,
    marginTop: 10,
    // zIndex: -8,
    marginRight: 35,
    //  marginRight:27
  },
  ADDropdown2ViewCC: {
    margin: 20,
    marginTop: 10,
    // zIndex: -8,
    marginRight: 27,
  },
  ADBtnView: {
    flexDirection: 'row',
    marginTop: 10,
  },
  ADcommAddMinView: {
    width: '100%',
  },
  ADmainView: {
    width: '100%',
    marginTop: 10,
  },

  ADmainHeading: {
    color: 'black',
    marginLeft: 28,
    marginTop: 12,
    marginBottom: 5,
    fontWeight: '500',
    fontSize: 16,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  ADTextfieldMainView: {
    margin: 20,
    marginTop: 10,
    zIndex: -9,
  },
  ADTextfieldMainText: {
    color: 'black',
    marginLeft: 10,
    fontWeight: '500',
    fontSize: 16,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  ADTextInputstyle: {
    marginLeft: 10,
    height: 30,
    borderColor: 'transparent',
    borderBottomColor: '#dadada',
    borderWidth: 0.5,
  },
  ADerrorText: {
    color: 'red',
    margin: 5,
    marginLeft: 10,
  },
  ADsecContainerView: {
    width: '100%',
    zIndex: -9,
  },
  ADbtnText: {
    color: 'black',
    fontWeight: '400',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    textAlign: 'center',
    fontSize: 14,
  },
  ADbtnText1: {
    fontWeight: '400',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    textAlign: 'center',
    fontSize: 14,
    color: 'white',
    textAlign: 'center',
  },
  ADbtnStyle: {
    marginHorizontal: 6,
    shadowColor: '#d3d3d3',
    shadowOpacity: 1,
    shadowRadius: 10,
    borderColor: 'white',
    backgroundColor: 'white',
    borderWidth: 1,
    borderColor: 'white',
    borderRadius: 0,
    justifyContent: 'center',
    // height: 35,
    width: 60,
    paddingVertical: 10,
    elevation: 2,
    // marginTop: -25,
  },
  ADbtnStyle1: {
    shadowColor: '#d3d3d3',
    shadowOpacity: 1,
    shadowRadius: 10,
    borderColor: 'white',
    marginHorizontal: 6,
    backgroundColor: '#B02A30',
    borderRadius: 0,
    justifyContent: 'center',
    // height: 35,
    paddingVertical: 10,
    width: 60,
    elevation: 2,
    // marginTop: -25,
  },
  ADDropdownView: {
    margin: 20,
    marginTop: 10,
    zIndex: -7,
  },
  ProductInfoContainer: {
    position: Platform.OS === 'web' ? 'fixed' : 'absolute',
    zIndex: 9999,
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    left: 0,
    right: 0,
    justifyContent: 'center',
    alignSelf: 'center',
    borderColor: 'black',
    borderWidth: 1,
  },

  RDProductInfoMainView: {
    width: '50%',
    backgroundColor: 'white',
    justifyContent: 'center',
    alignSelf: 'center',
    borderColor: 'black',
    borderWidth: 1,
  },
  RDProductInfoMainView_LDPI: {
    width: '100%',
    backgroundColor: 'white',
    justifyContent: 'center',
    alignSelf: 'center',
    borderColor: 'black',
    borderWidth: 1,
  },
  RDProductInfoMainView_MDPI: {
    width: '100%',
    backgroundColor: 'white',
    justifyContent: 'center',
    alignSelf: 'center',
    borderColor: 'black',
    borderWidth: 1,
  },

  RDProductInfoMainView_HDPI: {
    width: '100%',
    backgroundColor: 'white',
    justifyContent: 'center',
    alignSelf: 'center',
    borderColor: 'black',
    borderWidth: 1,
  },
  RDProductInfoMainView_XHDPI: {
    width: '100%',
    backgroundColor: 'white',
    justifyContent: 'center',
    alignSelf: 'center',
    borderColor: 'black',
    borderWidth: 1,
  },

  ProductInfoMainView: {
    width: 800,
    backgroundColor: 'white',
    justifyContent: 'center',
    alignSelf: 'center',
    borderColor: 'black',
    borderWidth: 1,
  },
  ProductInfoMainView_LDPI: {
    width: '100%',
  },
  ProductInfoMainView_MDPI: {
    width: '100%',
  },
  ProductInfoMainView_HDPI: {
    width: '100%',
  },
  ProductInfoMainView_XHDPI: {
    width: '100%',
  },
  Dropdown_IL_LDPI: {
    flexDirection: 'column',
  },
  Dropdown_IL_MDPI: {
    flexDirection: 'column',
  },
  Dropdown_IL_HDPI: {
    flexDirection: 'column',
  },
  Dropdown_IL_XHDPI: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingBottom: 10,
  },
  Dropdown_IL_LAPTOP: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingBottom: 10,
  },
  Dropdown_IL_XXXHDPI: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingBottom: 10,
  },
  Dropdown_IL_XXHDPI: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingBottom: 10,
  },
  PIheaderMainView: {
    height: responsiveHeight(89),
    backgroundColor: 'white',
  },
  PIheaderMainView_HDPI: {
    // height: null,
    backgroundColor: 'white',
  },
  // PIheaderMainView_XHDPI: {
  //   // height: null,
  //   backgroundColor: 'white',
  // },
  // PIheaderMainView_XXHDPI: {
  //   // height: null,
  //   backgroundColor: 'white',
  // },
  // PIheaderMainView_XXXHDPI: {
  //   // height: null,
  //   backgroundColor: 'white',
  // },
  PIheaderMainView_MDPI: {
    // height: null,
    backgroundColor: 'white',
  },
  PIheaderMainView_LDPI: {
    // height: null,
    backgroundColor: 'white',
  },
  PIheaderSecView: {
    padding: 10,
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomColor: '#e5e5e5',
    borderBottomWidth: 1,
  },
  PIheaderSecView_MDPI: {
    padding: 10,
    // flexDirection: 'row',
    alignItems: 'flex-end',
    flexDirection: 'column-reverse',
    borderBottomColor: '#e5e5e5',
    borderBottomWidth: 1,
  },
  PIheaderSecView_LDPI: {
    padding: 10,
    // flexDirection: 'row',
    alignItems: 'flex-end',
    flexDirection: 'column-reverse',
    borderBottomColor: '#e5e5e5',
    borderBottomWidth: 1,
  },
  topknowmoreButtons: {
    flexDirection: 'row',
    marginBottom: null,
  },
  topknowmoreButtons_MDPI: {
    flexDirection: 'row',

    marginBottom: 5,
  },
  topknowmoreButtons_LDPI: {
    flexDirection: 'row',
    marginBottom: 5,
  },
  PIheaderImage: {
    width: '42%',
    height: 80,
    alignSelf: 'center',
    marginRight: 8,
  },
  PIheaderImage_LDPI: {
    width: '100%',
    height: 90,
    alignSelf: 'center',
    marginRight: 8,
  },
  PIheaderImage_MDPI: {
    width: '100%',
    height: 90,
    alignSelf: 'center',
    marginRight: 8,
  },
  PIheaderImage_HDPI: {
    width: '50%',
    height: 80,
    alignSelf: 'center',
    marginRight: 8,
  },
  PIheaderBtnView: {
    flexDirection: 'row',
    width: '58%',
    display: Platform.OS === 'web' ? 'inline-block' : 'flex',
  },
  PIheaderBtnstyle: {
    borderRadius: 20,
    marginTop: 5,
    backgroundColor: '#B02A31',
    width: 100,
  },
  PIheaderBtn1style: {
    display: Platform.OS === 'web' ? 'inline-block' : 'flex',
    height: 35,
    width: '50%',
    marginLeft: 'auto',
  },
  PIheaderBtnText: {
    fontSize: 14,
    color: 'white',
    lineHeight: Platform.OS === 'web' ? 2 : null,
    // padding: Platform.OS === 'web' ? 5 : null,
    textAlign: 'center',
  },
  ClosePIheaderBtnText: {
    fontSize: 14,
    color: '#333',
    lineHeight: Platform.OS === 'web' ? 2 : null,
    padding: Platform.OS === 'web' ? 5 : null,
    textAlign: 'center',
  },
  PIheaderBtn1Text: {
    fontSize: 14,
    color: 'white',
    textAlign: 'center',
    width: 100,
    borderRadius: 20,
    backgroundColor: '#B02A31',
    marginTop: 5,
    padding: 10,
    marginRight: 5,
  },
  PITitlemainView: {
    padding: 15,
  },
  PITitlemainText: {
    color: '#333',
    fontSize: 18,
    fontWeight: '700',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  PITitleMainHeadingText: {
    color: '#333',
    fontSize: 14,
    fontWeight: 'bold',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  PITitleMainSubHeadingText: {
    color: '#333',
    fontSize: 14,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  PITitleView: {
    marginTop: 10,
    marginBottom: 10,
  },
  PITitleView2: {
    marginTop: 5,
  },
  PIoffersView: {
    marginTop: 10,
    marginBottom: 5,
  },
  PIOffersMainView: {
    paddingLeft: 20,
    paddingRight: 20,
  },
  PIOfferscontentView: {
    margin: 5,
    flexDirection: 'row',
  },
  PIOfferscontentText: {
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    textAlign: 'left',
    height: 17,
    width: 17,
    overflow: 'hidden',
    borderRadius: 10,
    borderColor: '#FE1B1A',
    color: 'white',
    backgroundColor: '#FE1B1A',
    margin: 0,
    padding: 0,
  },
  PIOfferscontentText1: {
    color: '#333',
    marginLeft: Platform.OS === 'web' ? 5 : 0,
    marginRight: 5,
  },
  PIOfferscontentlistitem: {
    width: '100%',
    display: Platform.OS === 'web' ? 'list-item' : 'flex',
  },
  PIOfferscontentlistitemText: {
    color: '#333',
    textAlign: 'left',
    fontSize: 14,
    fontWeight: '400',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  PIOffersTreeElement: {
    color: '#333',
    marginTop: 5,
    textAlign: 'left',
    fontSize: 14,
    fontWeight: '400',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    display: Platform.OS === 'web' ? 'list-item' : 'flex',
    marginLeft: 10,
  },
  PIOffersLinkbtnstyle_: {},
  PIknowMoreHEADING: {
    color: '#333',
    fontSize: 14,
    fontWeight: 'normal',
    marginTop: 20,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  PIlinkText: {
    color: '#337ab7',
  },
  PIknowMoreText: {
    color: '#333',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontSize: 14,
    fontWeight: 'normal',
    marginTop: 15,
  },
  PIOffersView: {
    padding: 10,
    marginTop: 5,
    borderTopWidth: 1,
    borderTopColor: '#e5e5e5',
    display: Platform.OS === 'web' ? 'inline-block' : null,
  },
  PIOffersView2: {
    borderRadius: 20,
    marginTop: 5,
    backgroundColor: '#B02A31',
    width: 100,
  },
  PIOffersinnerView: {
    width: '100%',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  PIapplyNowtext: {
    fontSize: 14,
    color: 'white',
    lineHeight: 2,
    padding: 5,
    textAlign: 'center',
  },
  PIclosetext: {
    fontSize: 14,
    color: 'white',
    textAlign: 'center',
    width: 100,
    borderRadius: 20,
    backgroundColor: '#B02A31',
    marginTop: 5,
    padding: 10,
    marginRight: 5,
  },
  PIclosebtn: {
    display: Platform.OS === 'web' ? 'inline-block' : 'flex',
    height: 35,
    width: '50%',
    marginLeft: 'auto',
  },
  ADPermHeadingText: {
    //color: '#A9A9A9',
    color: 'black',
    marginLeft: 28,
    marginTop: 12,
    marginBottom: 5,
    //  fontWeight: '800',
    fontSize: 17,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  ADPermHeadingTextNew: {
    //color: '#A9A9A9',
    color: 'grey',
    marginLeft: 10,
    marginTop: 12,
    marginBottom: 5,
    //  fontWeight: '800',
    fontSize: 17,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  TextinputMainViewRow: {
    flexDirection: 'row',
    marginBottom: 10
  },
  ADinputnameText: {
    color: 'black',
    marginLeft: 10,
    fontWeight: '500',
    fontSize: 16,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  ADinputnameTextPassport: {
    color: 'black',
    marginLeft: 6,
    fontWeight: '500',
    fontSize: 16,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  ADinputnameTextParental: {
    color: 'black',
    marginLeft: 10,
    fontWeight: '500',
    fontSize: 16,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  ADinputnameTextParental_LDPI: {
    color: 'black',
    marginLeft: 10,
    fontWeight: '500',
    fontSize: 13,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  ADinputnameTextParent: {
    color: 'black',
    marginLeft: 10,
    fontWeight: '500',
    fontSize: 16,
    marginBottom: 10,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  ADinputnameTextParent_LDPI: {
    color: 'black',
    fontWeight: '500',
    fontSize: 13,
    marginLeft: 18,
    marginTop: 8,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  ADinputnameTextParent_MDPI: {
    color: 'black',
    fontWeight: '500',
    fontSize: 13,
    marginLeft: 18,
    marginTop: 8,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  ADinputnameMainView: {
    margin: 20,
    marginRight: 40,
    marginTop: 10,
    zIndex: -9,
  },
  ADinputnameMainViewfatca: {
    margin: 20,
    marginRight: 0,
    marginLeft: 0,
    marginTop: 10,
    zIndex: -9,
  },
  RLTextInputFieldStyle: {
    marginLeft: 10,
    marginRight: 10,
    // height: 30,
    color: 'black',
    paddingLeft: 10,
    borderColor: '#ccc',
    // borderBottomColor: '#dadada',
    borderWidth: 0.5,
    paddingTop: 10,
    paddingBottom: 10,
  },
  RlchangeBtnText: {
    padding: 6,
    color: 'white',
    paddingLeft: 40,
    paddingRight: 40,
  },
  ADTextInputFieldStyle: {
    // width: '100%',
    marginLeft: 10,
    // height: 30,
    color: 'black',
    borderColor: 'transparent',
    borderBottomColor: '#dadada',
    borderWidth: 0.5,
    paddingTop: 10,
    paddingBottom: 10,
  },
  ADTextInputFieldStyleOrgDetails: {
    width: '100%',
    // marginLeft: 10,
    // height: 30,
    color: 'black',
    borderColor: 'transparent',
    borderBottomColor: '#dadada',
    borderWidth: 0.5,
    paddingTop: 10,
    paddingBottom: 10,
    // marginLeft:10
  },
  ADinputErrorText: {
    color: 'red',
    margin: 5,
    marginLeft: 10,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  ADBirthPlaceTextInput: {
    textTransform: 'uppercase',
    width: '100%',
    // height: 30,
    color: 'black',
    borderColor: 'transparent',
    borderBottomColor: '#dadada',
    borderWidth: 0.5,
    paddingTop: 10,
    paddingBottom: 10,
  },
  ADcommAddressContainer: {
    width: '100%',
    marginTop: 10,
    zIndex: -9,
  },
  ADcommAddressMainContainer: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '70%',
    borderRadius: 10,
  },
  ADcommAddressMainContainer_LDPI: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '90%',
    borderRadius: 10,
  },
  ADcommAddressMainContainer_MDPI: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '90%',
    borderRadius: 10,
  },
  ADmainwidth: {
    width: '100%',
  },
  ADmainwidthGov: {
    width: '100%',
    marginTop: 70,
  },
  ADbirthPlaceView: {
    zIndex: -9,
    marginTop: 10,
  },
  ADbirthPlaceText: {
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontSize: 14,
    lineHeight: 20,
    //marginTop: 20,
    // marginLeft: 5,
  },
  ADcityTextView: {
    width: '95%',
    marginLeft: 10,
  },
  ILradiobtnMainView: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    // marginTop: 30,
  },
  NDcomponentView: {
    marginLeft: 9,
    marginTop: 10,
  },
  NDTextinputstyle: {
    width: '100%',
    marginLeft: 10,
    borderColor: 'transparent',
    borderBottomColor: '#dadada',
    borderWidth: 0.5,
    color: 'black',
    paddingTop: 10,
    paddingBottom: 10,
    textTransform: 'uppercase',
  },
  NDTextinputstyleFatca: {
    width: '100%',
    borderColor: 'transparent',
    borderBottomColor: '#dadada',
    borderWidth: 0.5,
    color: 'black',
    paddingTop: 10,
    paddingBottom: 10,
    textTransform: 'uppercase',
    marginTop: 10
  },
  NDTextinputstyleFatca_LDPI: {
    width: '100%',
    borderColor: 'transparent',
    borderBottomColor: '#dadada',
    borderWidth: 0.5,
    color: 'black',
    paddingTop: 10,
    paddingBottom: 10,
    textTransform: 'uppercase',
    marginTop: 10
  },
  NDTextinputstyleFatca_MDPI: {
    width: '100%',
    borderColor: 'transparent',
    borderBottomColor: '#dadada',
    borderWidth: 0.5,
    color: 'black',
    paddingTop: 10,
    paddingBottom: 10,
    textTransform: 'uppercase',
    marginTop: 10
  },
  NDTextinputstyleFatca_HDPI: {
    width: '100%',
    borderColor: 'transparent',
    borderBottomColor: '#dadada',
    borderWidth: 0.5,
    color: 'black',
    paddingTop: 10,
    paddingBottom: 10,
    textTransform: 'uppercase',
    marginTop: 10
  },
  AMCbtnflexView: {
    flexDirection: 'row',
  },
  AMCbtnflexView_LDPI: {
    flexDirection: 'row',
  },
  AMCbtnflexView_MDPI: {
    flexDirection: 'row',
  },
  modelStyle: {
    position: Platform.OS === 'web' ? 'fixed' : 'absolute',
    zIndex: 9,
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    left: 0,
    right: 0,
    marginTop: 'auto',
    marginBottom: 'auto',
    top: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
  },
  // modelStyle_HDPI: {
  //   position: 'absolute',
  //   height: '110%',
  // },
  // modelStyle_MDPI: {
  //   position: 'absolute',
  //   height: '110%',
  // },
  // modelStyle_LDPI: {
  //   position: 'absolute',
  //   height: '110%',
  // },
  OVresendBtnText: {
    color: '#B02A30',
    // textDecorationLine: 'underline',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontWeight: '600',

  },
  OVcontBtnText: {
    fontSize: 12,
    color: '#696969',
    fontWeight: '500',
    textAlign: 'center',
    color: 'white',
  },

  AutoloanOVcontBtnText: {
    fontSize: 16,
    color: '#696969',
    fontWeight: 'bold',
    textAlign: 'center',
    color: 'white',
  },

  OVotperror: {
    color: 'red',
  },
  OVPANDivide: {
    flex: Platform.OS === 'web' ? 1 : null,
    marginBottom: 5,
  },
  subStyle: { backgroundColor: 'white', borderWidth: 1, width: '57%' },
  subStyle_XXHDPI: { width: '67%' },
  subStyle_XHDPI: { width: '67%' },
  subStyle_HDPI: {
    width: '67%',
    // marginTop: -50
  },
  subStyle_MDPI: {
    width: '77%',
    // marginTop: -50
  },
  subStyle_LDPI: {
    width: '87%',
    //  marginTop: -50
  },
  subStyleVisa: { backgroundColor: 'white', borderWidth: 1, width: '57%' },
  subStyleVisa_XXHDPI: { width: '67%' },
  subStyleVisa_XHDPI: { width: '67%' },
  subStyleVisa_HDPI: {
    width: '67%',
    // marginTop: -50
  },
  subStyleVisa_MDPI: {
    width: '77%',
    // marginTop: -50
  },
  subStyleVisa_LDPI: {
    width: '87%',
    marginTop: '11%'
    //  marginTop: -50
  },
  subStylePassport: { backgroundColor: 'white', borderWidth: 1, width: '57%' },
  subStylePassport_XXHDPI: { width: '67%' },
  subStylePassport_XHDPI: { width: '67%' },
  subStylePassport_HDPI: {
    width: '67%',
    // marginTop: -50
  },
  subStylePassport_MDPI: {
    width: '77%',
    marginTop: '11%'
    // marginTop: -50
  },
  subStylePassport_LDPI: {
    width: '87%',
    marginTop: '18%'
    //  marginTop: -50
  },
  knowsubStyle: { backgroundColor: 'white', borderWidth: 1, width: '57%' },
  knowsubStyle_XXHDPI: { width: '67%' },
  knowsubStyle_XHDPI: { width: '67%' },
  knowsubStyle_HDPI: {
    width: '67%',
    // marginTop: -50
  },
  knowsubStyle_MDPI: {
    width: '77%',
    // marginTop: -50
  },
  knowsubStyle_LDPI: {
    width: '87%',
    marginTop: 40,
  },
  otpContainerStyle: {
    width: '50%',
    flexDirection: 'row',
    marginVertical: 10,
  },
  otpContainerStyle_XXHDPI: {
    width: '100%',
  },
  otpContainerStyle_XHDPI: {
    width: '100%',
  },
  otpContainerStyle_HDPI: {
    width: '100%',
  },
  otpContainerStyle_MDPI: {
    width: '100%',
  },
  otpContainerStyle_LDPI: {
    width: '100%',
  },
  OVotpTextView: {
    marginBottom: 5,
  },
  OVotpText: {
    fontSize: 12,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  otpStyle: {
    padding: 5,
    margin: 3,
    fontSize: Platform.OS === 'web' ? 14 : fontInPercentage(6),
    width: Platform.OS === 'web' ? 33.5 : widthInPercentage(9),
    height: Platform.OS === 'web' ? 33.5 : widthInPercentage(9),
    textAlign: 'center',
    borderColor: '#ccc',
    borderRadius: 2,
    // borderWidth: 0.5,
    borderWidth: 1,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    color: '#555',
  },
  otpStyle_XXHDPI: {
    margin: '1%',
    fontSize: 12,
    textAlign: 'center',
    borderColor: '#dadada',
    borderRadius: 2,
    //borderWidth: 0.5,
    borderWidth: 1,
  },
  otpStyle_XHDPI: {
    margin: '1%',
    fontSize: 12,
    textAlign: 'center',
    borderColor: '#dadada',
    borderRadius: 2,
    // borderWidth: 0.5,
    borderWidth: 1,
  },
  OVcloseBtnstyle: {
    borderRadius: 0,
    paddingHorizontal: 5,
    alignSelf: 'flex-end',
  },
  OVcloseBtnText: {
    fontSize: 19,
    fontWeight: '500',
    textAlign: 'center',
    color: 'grey',
    bottom: 15,
    left: 10,
    position: 'relative',
  },
  OVviewpadding: {
    padding: 20,
  },
  OVviewPINinputLogoFlex: {
    flexDirection: 'row',
  },
  OVcloseBtnView: {
    flex: 1,
  },
  OVcloseBtnView_LDPI: {
    flex: 0.2,
  },
  OVcloseBtnView_MDPI: {
    flex: 0.2,
  },
  OVcloseKnowBtnView: {
    flex: 1,
  },
  OVcloseKnowBtnView_LDPI: {
    flex: 0.2,
    marginLeft: 241,
  },
  OVcloseKnowBtnView_MDPI: {
    flex: 0.2,
    marginLeft: 241,
  },
  OVmobnoVerView: {
    marginBottom: 10,
    flex: 5,
  },
  OVmobnoVerView_LDPI: {
    marginBottom: 10,
    flex: 0.8,
  },
  OVmobnoVerView_MDPI: {
    marginBottom: 10,
    flex: 0.8,
  },
  OVmobnoVerText: {
    fontSize: 16,
    fontWeight: '600',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  OVmobnoVerText1: {
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#c42121',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  OVmobnoVerText1_LDPI: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#c42121',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  OVmobnoVerText1_MDPI: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#c42121',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  OVmobnoVerText1_HDPI: {
    fontSize: 18,
    textAlign: 'center',
    fontWeight: 'bold',
    color: '#c42121',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  otpStyle_HDPI: {
    margin: '1%',
    fontSize: 12,
    textAlign: 'center',
    borderColor: '#dadada',
    borderRadius: 2,
    //borderWidth: 0.5,
    borderWidth: 1,
  },
  PininputPnValid: {
    width: '100%',
    flexDirection: 'row',
  },
  PininputPnValid_LDPI: {
    width: '100%',
    flexDirection: 'column',
  },
  PininputPnValid_MDPI: {
    width: '100%',
    flexDirection: 'column',
  },
  otpStyle_MDPI: {
    margin: '1%',
    fontSize: 12,
    textAlign: 'center',
    borderColor: '#dadada',
    borderRadius: 2,
    //borderWidth: 0.5,
    borderWidth: 1,
  },
  otpStyle_LDPI: {
    margin: '1%',
    fontSize: 12,
    textAlign: 'center',
    borderColor: '#dadada',
    borderRadius: 2,
    //borderWidth: 0.5,
    borderWidth: 1,
  },
  panimg: {
    width: Platform.OS === 'web' ? 100 : 50,
    height: Platform.OS === 'web' ? 100 : 50,
    marginRight: Platform.OS === 'web' ? '35%' : 0,
    marginLeft: Platform.OS === 'web' ? '35%' : 0,
    marginTop: Platform.OS === 'web' ? 0 : 5,
  },
  panimg_XHDPI: {
    width: Platform.OS === 'web' ? 90 : 50,
    height: Platform.OS === 'web' ? 90 : 50,
  },
  panimg_HDPI: {
    width: Platform.OS === 'web' ? 80 : 50,
    height: Platform.OS === 'web' ? 80 : 50,
  },
  panimg_MDPI: {
    width: Platform.OS === 'web' ? 60 : 50,
    height: Platform.OS === 'web' ? 60 : 50,
  },
  panimg_LDPI: {
    width: Platform.OS === 'web' ? 60 : 50,
    height: Platform.OS === 'web' ? 60 : 50,
  },
  panverified: {
    // bottom: Platform.OS === 'web' ? '45px' : 0,
    width: '95%',
    margin: 0,
    padding: 0,
  },
  panverified_LDPI: {
    bottom: Platform.OS === 'LDPI' ? 0 : null,
    width: '95%',
    margin: 0,
    padding: 0,
  },
  panverified_MDPI: {
    bottom: Platform.OS === 'MDPI' ? 0 : null,
    width: '95%',
    margin: 0,
    padding: 0,
  },
  pantext: {
    fontSize: 16,
    fontWeight: '600',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    textAlign: Platform.OS === 'web' ? 'center' : 'left',
  },
  otpExpire: {
    color: 'black',
    fontWeight: 'bold',
    alignSelf: 'center',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  otpexpSection: {
    flexDirection: 'row',
    marginTop: 10,
    bottom: Platform.OS === 'web' ? '10px' : 0,
  },
  resend: {
    marginVertical: Platform.OS === 'web' ? null : 10,
    bottom: Platform.OS === 'web' ? '10px' : null,
    marginBottom: 10,
  },
  otpContinue: {
    marginTop: 0,
    bottom: Platform.OS === 'web' ? '5px' : null,
  },
  otpContinueMain: {
    backgroundColor: '#B02A31',
    borderRadius: 20,
    height: 35,
    width: 150,
    marginBottom: 0,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },

  AutoloanotpContinueMain: {
    backgroundColor: '#0c4678',
    //  borderRadius: 20,
    // height: 35,
    // width: 150,
    padding: 12,
    paddingLeft: 20,
    paddingRight: 20,
    marginBottom: 0,
    textAlign: 'center',
    // alignItems: 'center',
    // justifyContent: 'center',
  },

  mainContainerStyle: { width: '100%', flexDirection: 'row' },
  mainContainerStyle_XXDPI: { flexDirection: 'column' },
  mainContainerStyle_XHDPI: { flexDirection: 'column' },
  mainContainerStyle_HDPI: { flexDirection: 'column' },
  mainContainerStyle_MDPI: { flexDirection: 'column' },
  mainContainerStyle_LDPI: { flexDirection: 'column' },

  MobileinputView: {
    margin: 30,
    marginTop: 10,
    paddingRight: Platform.OS === 'web' ? 0 : 20,
    zIndex: -1,
  },
  MandatoryText: {
    fontSize: 14,
    color: 'red',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  MandatoryTextView: {
    marginBottom: 20,
    textAlign: 'right',
    marginHorizontal: 30,
    zIndex: -1,
  },
  MobileinputText: {
    color: 'black',
    fontWeight: '400',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontSize: 16,
    marginBottom: 0,
    zIndex: -1,
    marginBottom: 5,
  },
  MobileinputTextFatca: {
    color: 'black',
    fontWeight: '400',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontSize: 16,
    marginBottom: 0,
    zIndex: -1,
    marginBottom: 5,
    marginLeft: 5
  },
  MobileinputView2: {
    flexDirection: 'row',
    marginLeft: Platform.OS === 'web' ? 0 : null,
  },
  MobileinputView3: {
    alignItems: 'center',
    justifyContent: 'center',
    borderBottomColor: 'rgb(218, 218, 218)',
    borderBottomWidth: 0.5,
  },
  MobileinputLeftText: {
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    marginTop: 1,
  },
  TextInputstyle4: {
    marginLeft: 0,
    color: 'black',
    //  height:30,
    borderColor: 'transparent',
    borderWidth: 0.5,
    borderBottomColor: '#dadada',
    paddingHorizontal: 5,
    paddingVertical: 0,
    paddingTop: 5,
    paddingBottom: 5,
  },
  TextInputstyle5: {
    color: 'black',
    marginLeft: 0,
    // height:30,
    borderColor: 'transparent',
    borderWidth: 0.5,
    borderBottomColor: '#dadada',
    paddingLeft: 5,
    paddingVertical: 0,
    zIndex: -1,
    paddingTop: 5,
    paddingBottom: 5,
    textTransform: 'uppercase',
  },
  TextInputstyleFatca: {
    color: 'black',
    marginLeft: 0,
    // height:30,
    borderColor: 'transparent',
    borderWidth: 0.5,
    borderBottomColor: '#dadada',
    paddingLeft: 5,
    paddingVertical: 0,
    zIndex: -1,
    paddingTop: 5,
    paddingBottom: 5,
    textTransform: 'uppercase',
    marginTop: 10
  },
  maincontainer1: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '95%',
    borderRadius: 10,
  },
  maincontainer1_HDPI: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '100%',
    borderRadius: 10,
  },
  maincontainer1_XHDPI: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '90%',
    borderRadius: 10,
  },
  maincontainer1_XXHDPI: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '90%',
    borderRadius: 10,
  },
  maincontainer1_XXXHDPI: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '95%',
    borderRadius: 10,
  },
  maincontainer1_LDPI: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '100%',
    borderRadius: 10,
  },
  maincontainer1_MDPI: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '100%',
    borderRadius: 10,
  },
  maincontainer_LDPI: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '90%',
    borderRadius: 10,
  },
  maincontainer_MDPI: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '90%',
    borderRadius: 10,
  },
  subcontainer: {
    width: '100%',
    marginTop: 60,
  },
  subcontainer_LDPI: {
    width: '100%',
    marginTop: 30,
  },
  subcontainer_MDPI: {
    width: '100%',
    marginTop: 30,
  },
  inputBlockview: {
    margin: 30,
    paddingRight: 0,
    marginTop: 30,
    zIndex: -9,
  },
  inputBlockview_LDPI: {
    margin: 20,
    paddingRight: 0,
    marginTop: 20,
    zIndex: -9,
  },
  inputBlockText: {
    color: 'black',
    marginLeft: Platform.OS === 'web' ? 0 : null,
    fontWeight: '400',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontSize: 16,
  },
  inputBlockInnerView: {
    marginTop: 10,
    flexDirection: 'row',
  },
  TextInputstyle1: {
    // flex: Platform.OS === 'web' ? 0 : 3,
    color: 'black',
    textAlign: 'center',
    justifyContent: 'center',
    marginTop: 2,
    width: 100,
    marginTop: 2,
    // height:30,
    borderColor: '#bdc1cc',
    borderWidth: 0.5,
    padding: 5,
  },
  edTextInputstyle1: {
    // flex: Platform.OS === 'web' ? 0 : 3,
    color: 'black',
    textAlign: 'center',
    justifyContent: 'center',
    marginTop: 2,
    width: 100,
    marginTop: 2,
    // height:30,
    borderColor: '#bdc1cc',
    borderWidth: 0.5,
    padding: 5,
  },
  edTextInputstyle1_LDPI: {
    // flex: Platform.OS === 'web' ? 0 : 3,
    color: 'black',
    textAlign: 'center',
    justifyContent: 'center',
    marginTop: 2,
    width: 80,
    marginTop: 2,
    // height:30,
    borderColor: '#bdc1cc',
    borderWidth: 0.5,
    padding: 5,
  },

  basicInputStyle: {
    color: 'black',
    marginTop: 2,
    width: 100,
    marginTop: 2,
    borderColor: '#bdc1cc',
    borderWidth: 0.5,
    padding: 5,
  },
  TextInputstyle1_LDPI: {
    // flex: Platform.OS === 'web' ? 0 : 3,
    color: 'black',
    textAlign: 'center',
    justifyContent: 'center',
    marginTop: 2,
    width: 80,
    marginTop: 2,
    // height:30,
    borderColor: '#bdc1cc',
    borderWidth: 0.5,
    padding: 5,
  },
  TextInputAfterShowTin: {
    // flex: Platform.OS === 'web' ? 0 : 2,
    width: '70%',
    color: 'black',
    marginLeft: 10,
    textAlign: 'center',
    justifyContent: 'center',
    marginTop: 2,
    borderColor: '#bdc1cc',
    borderWidth: 0.5,
  },
  TextInputstyle2: {
    // flex: Platform.OS === 'web' ? 0 : 2,
    width: 100,
    color: 'black',
    marginLeft: 10,
    textAlign: 'center',
    justifyContent: 'center',
    marginTop: 2,
    borderColor: '#bdc1cc',
    borderWidth: 0.5,
  },
  edTextInputstyle2: {
    //flex: Platform.OS === 'web' ? 0 : 2,
    width: 100,
    color: 'black',
    marginLeft: 10,
    textAlign: 'center',
    justifyContent: 'center',
    marginTop: 2,
    borderColor: '#bdc1cc',
    borderWidth: 0.5,
  },
  edTextInputstyle2_LDPI: {
    //flex: Platform.OS === 'web' ? 0 : 2,
    width: 80,
    color: 'black',
    marginLeft: 10,
    textAlign: 'center',
    justifyContent: 'center',
    marginTop: 2,
    borderColor: '#bdc1cc',
    borderWidth: 0.5,
  },
  TextInputstyle2_LDPI: {
    // flex: Platform.OS === 'web' ? 0 : 2,
    width: 80,
    color: 'black',
    marginLeft: 10,
    textAlign: 'center',
    justifyContent: 'center',
    marginTop: 2,
    // height:30,
    borderColor: '#bdc1cc',
    borderWidth: 0.5,
  },
  TextInputstyle3: {
    // flex: Platform.OS === 'web' ? 0 : 1,
    color: 'black',
    marginLeft: 10,
    textAlign: 'center',
    justifyContent: 'center',
    marginTop: 2,
    width: 50,
    //  height:30,
    borderColor: '#bdc1cc',
    borderWidth: 0.5,
  },
  edTextInputstyle3: {
    //flex: Platform.OS === 'web' ? 0 : 1,
    color: 'black',
    marginLeft: 10,
    textAlign: 'center',
    justifyContent: 'center',
    marginTop: 2,
    width: 50,
    //  height:30,
    borderColor: '#bdc1cc',
    borderWidth: 0.5,
  },
  edTextInputstyle3_LDPI: {
    //flex: Platform.OS === 'web' ? 0 : 1,
    color: 'black',
    marginLeft: 10,
    textAlign: 'center',
    justifyContent: 'center',
    marginTop: 2,
    width: 40,
    //  height:30,
    borderColor: '#bdc1cc',
    borderWidth: 0.5,
  },
  TextInputstyle3_LDPI: {
    // flex: Platform.OS === 'web' ? 0 : 1,
    color: 'black',
    marginLeft: 10,
    textAlign: 'center',
    justifyContent: 'center',
    marginTop: 2,
    width: 40,
    //  height:30,
    borderColor: '#bdc1cc',
    borderWidth: 0.5,
  },
  TextInputstylePassport: {
    color: 'black',
    marginLeft: 10,
    textAlign: 'center',
    justifyContent: 'center',
    marginTop: 2,
    width: 50,
    borderColor: '#bdc1cc',
    borderWidth: 0.5,
  },
  TextInputstylePassport_LDPI: {
    color: 'black',
    marginLeft: 0,
    textAlign: 'center',
    justifyContent: 'center',
    marginTop: 2,
    width: 50,
    borderColor: '#bdc1cc',
    borderWidth: 0.5,
  },
  TextInputerror: {
    color: 'red',
    margin: 5,
    marginLeft: 10,
  },
  adhaarpanverification: {
    marginLeft: 20,
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontSize: 15,
    color: 'black',
  },

  EmailInputView: {
    marginVertical: 10,
    marginHorizontal: 20,
    paddingRight: 20,
    // zIndex: -9,
  },
  EmailInputheading: {
    color: 'black',
    marginLeft: 10,
    fontWeight: '400',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontSize: 16,
    marginBottom: 0,
  },
  EmailInputheadingParental: {
    color: 'black',
    marginLeft: 10,
    fontWeight: '400',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontSize: 16,
    marginBottom: 0,
  },
  EmailInputheadingParental_LDPI: {
    color: 'black',
    marginLeft: 10,
    fontWeight: '400',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontSize: 13,
    marginBottom: 0,
  },
  checkboxView: {
    display: 'flex',
    marginLeft: 10,
    marginTop: 10,
    zIndex: -1,
  },
  checkboxstyle: {
    top: 0,
    marginTop: -6,
    position: 'absolute',
  },
  personalDetailsText: {
    lineHeight: 20,
    // width: '35%', // please check other products while doing changes
    letterSpacing: 0.5,
    color: 'black',
    fontSize: 14,
    marginLeft: 5,
    position: 'relative',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  emailtext: {
    width: '100%',
    fontSize: 14,
    marginLeft: 10,
    borderColor: 'transparent',
    borderWidth: 0.5,
    borderBottomColor: "#dadada",
    // paddingTop: 5,
    // paddingBottom: 5,
    color: "black",
    borderBottomColor: '#dadada',
    paddingTop: 5,
    paddingBottom: 5,
    color: 'black',
  },

  // web view
  topsection_mainConatiner: {
    width: '100%',
    // marginBottom: 25,
    // marginTop: 10,
    marginLeft: 0,
    marginRight: 0,
    alignItems: 'center',
    flexDirection: 'row',
    flex: 1,
  },
  topsection_component1: {
    backgroundColor: '#F36414',
    alignSelf: 'center',
    width: 40,
    height: 40,
    borderRadius: 35,
  },
  topsection_component2: {
    backgroundColor: '#F36414',
    // marginLeft: '0',
    // marginRight: 0,
    alignSelf: 'center',
    width: 40,
    height: 28,
    marginTop: 8,
    borderRadius: 35,
    marginLeft: 0,
  },
  Topsection_btn1: {
    resizeMode: 'contain',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  Topsection_btn2: {
    resizeMode: 'contain',
    width: '100%',
    height: '100%',
  },
  topsection_image1: {
    // width: '65%',
    // height: '65%',
    alignSelf: 'center',
    resizeMode: 'contain',
    width: 20,
    height: 15,
  },
  topsection_image2: {
    width: '80%',
    height: '80%',
    alignSelf: 'center',
    resizeMode: 'contain',
  },
  ALtopsection_image2: {
    width: '100%',
    height: '100%',
    alignSelf: 'center',
    resizeMode: 'contain',
  },
  arrowStyle: {
    width: 0,
    height: 0,
    backgroundColor: 'transparent',
    borderStyle: 'solid',
    borderTopWidth: 7,
    borderRightWidth: 14,
    borderBottomWidth: 7,
    borderTopColor: 'transparent',
    borderBottomColor: 'transparent',
    borderRightColor: '#B02A30',
    alignSelf: 'center',
  },
  topsection_text: {
    fontSize: 18,
    paddingVertical: 20,
    color: 'white',
    marginLeft: 5,
    fontWeight: 'bold',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },

  //mobile view
  topsection_Mobilecontainer1: {
    marginBottom: 5,
    marginBottom: 25,
    marginTop: 25,
    marginLeft: 0,
    marginRight: 0,
    alignItems: 'center',
    flexDirection: 'row',
  },
  topsection_Mobilecontainer2: {
    backgroundColor: '#F36414',
    marginLeft: '0',
    marginRight: 0,
    alignSelf: 'center',
    width: 25,
    height: 28,
    borderRadius: 35,
    marginLeft: 0,
    position: 'absolute',
    right: 0,
    top: 0,
    marginRight: 15,
    marginTop: 15,
  },
  topsection_mobileText: {
    marginLeft: 5,
    fontSize: 16,
    color: 'white',
  },
  topsection_mobileView: {
    backgroundColor: '#F36414',
    alignSelf: 'center',
    borderRadius: 35,
  },
  topsection_Mobilebtn1: {
    resizeMode: 'contain',
    alignItems: 'center',
    justifyContent: 'center',
  },
  topsection_Mobilebtn2: {
    marginRight: '2%',
  },
  topsection_Mobileimg1: {
    width: 30,
    height: 30,
    alignSelf: 'center',
  },
  topsection_Mobileimg2: {
    width: 25,
    height: 25,
    alignSelf: 'center',
    resizeMode: 'contain',
  },
  main: {
    flexDirection: 'row',
    backgroundColor: '#f6f6f6',
    height: '80px',
  },
  TrackbtnView: {
    marginTop: 10,
    flexDirection: 'row',
    alignSelf: 'flex-end',
    marginRight: 10,
  },
  TrackbtnText: {
    fontSize: 14,
    color: '#696969',
    fontWeight: '400',
    textAlign: 'center',
    color: 'white',
  },
  refreshbtnView: {
    flexDirection: 'row',
    marginTop: 10,
    alignSelf: 'flex-end',
    marginRight: 10,
  },
  refreshbtnstyle: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#B02A31',
    borderColor: 'white',
    borderRadius: 20,
    height: 40,
    width: 120,
  },
  Trackbtnstyle: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#B02A31',
    borderColor: 'white',
    borderRadius: 20,
    height: 40,
    width: 120,
  },
  refreshbtntext: {
    fontSize: 14,
    color: '#696969',
    fontWeight: '400',
    textAlign: 'center',
    color: 'white',
  },
  autocompleteContainer: {
    flex: 1,
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: 9999,
    transform: [{ translate: [0, 0, 1] }],
  },
  PItopbtnView: {
    flexDirection: 'row',
    width: '58%',
    justifyContent: 'flex-end',
  },
  PItopbtnstyleView: {
    backgroundColor: '#B02A31',
    paddingVertical: 10,
    paddingHorizontal: 15,
    // margin: 5,
    justifyContent: 'center',
    borderRadius: 20,
  },
  ClosePItopbtnstyleView: {
    backgroundColor: '#ffffff',
    paddingVertical: 13,
    paddingHorizontal: 15,
    borderWidth: 0.5,
    borderColor: '#ccc',
    // margin: 5,

    borderRadius: 20,
  },
  PIcloseBtnSTYLE: {
    backgroundColor: '#B02A31',
    padding: 13,
    margin: 5,
    borderRadius: 20,
    width: 100,
  },
  cibilscore: {
    textAlign: 'right',
    borderRadius: 40,
    padding: 10,
    textAlign: 'right',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    display: Platform.OS === 'web' ? 'inline-block' : null,
    backgroundColor: 'rgb(243, 100, 20)',
    borderRadius: 50,
  },
  cibilscore_LDPI: {
    textAlign: 'right',
    borderRadius: 5,
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    display: Platform.OS === 'web' ? 'inline-block' : null,
    backgroundColor: 'rgb(243, 100, 20)',
    padding: 10,
  },
  cibilscore_MDPI: {
    textAlign: 'right',
    borderRadius: 5,
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    display: Platform.OS === 'web' ? 'inline-block' : null,
    backgroundColor: 'rgb(243, 100, 20)',
    padding: 10,
  },
  cibiltext: {
    display: Platform.OS === 'web' ? 'block' : 'flex',
    fontSize: 22,
    textAlign: 'center',
    width: 120,
    paddingHorizontal: 3,
    color: 'white',
  },
  cibiltext_LDPI: {
    display: Platform.OS === 'web' ? 'block' : 'flex',
    fontSize: 16,
    textAlign: 'center',
    width: 60,
    paddingHorizontal: 3,
    color: 'white',
  },
  cibiltext_MDPI: {
    display: Platform.OS === 'web' ? 'block' : 'flex',
    fontSize: 16,
    textAlign: 'center',
    width: 60,
    paddingHorizontal: 3,
    color: 'white',
  },

  ODmainwidth: {
    position: Platform.OS === 'web' ? 'fixed' : 'absolute',
    margin: 30,
    marginTop: 0,
    zIndex: 9999,
    marginTop: 20,
    width: 500,
    padding: 20,
    marginLeft: 'auto',
    marginRight: 'auto',
    left: 0,
    right: 0,
    borderRadius: 8,
    backgroundColor: 'white',
    justifyContent: 'center',
    alignSelf: 'center',
    borderColor: 'black',
    borderWidth: 1,
  },
  ODsecContainer: {
    backgroundColor: 'white',
  },

  imageContainer: {
    margin: 5,
    marginLeft: 20,
    marginRight: 20,
    height: 150,

    flexDirection: 'row',
  },
  imageContainer_LDPI: {
    padding: 15,
    margin: 0,
    marginLeft: 0,
    marginRight: 0,
    height: 150,
    paddingBottom: 5,
    flexDirection: 'row',
  },
  imageContainer_MDPI: {
    padding: 15,
    margin: 0,
    marginLeft: 0,
    marginRight: 0,
    height: 150,
    paddingBottom: 5,
    flexDirection: 'row',
  },
  imageContainer_HDPI: {
    margin: 0,
    marginLeft: 0,
    marginRight: 0,
    height: 180,
    flexDirection: 'row',
  },
  imageContainer_XHDPI: {
    height: 200,
    flexDirection: 'row',
  },
  imageContainer_XXHDPI: {
    height: 200,
    flexDirection: 'row',
  },
  imageContainer_XXXHDPI: {
    height: 200,
    flexDirection: 'row',
  },
  maincontainerwidthAutoLoan: {
    width: '100%',
    //marginTop: 10,
  },

  maincontainerAL1: {
    alignSelf: 'center',
    width: '90%',
    borderRadius: 8,
    shadowOpacity: 0.75,
    shadowRadius: 5,
    shadowColor: 'rgba(0,0,0,.4)',
    shadowOffset: { height: 0, width: 0 },
  },
  maincontainerAL1_LDPI: {
    alignSelf: 'center',
    width: '100%',
    borderRadius: 0,
    shadowOpacity: 0.75,
    shadowRadius: 5,
    shadowColor: 'rgba(0,0,0,.4)',
    shadowOffset: { height: 0, width: 0 },
  },
  maincontainerAL1_MDPI: {
    alignSelf: 'center',
    width: '100%',
    borderRadius: 0,
    shadowOpacity: 0.75,
    shadowRadius: 5,
    shadowColor: 'rgba(0,0,0,.4)',
    shadowOffset: { height: 0, width: 0 },
  },

  buttonMainViewPersonalD: {
    marginLeft: 32,
    marginRight: 27,
    flexDirection: 'row',
    marginBottom: 20,
  },

  buttonMainViewPersonalD_LDPI: {
    alignContent: 'center',
    flexDirection: 'column',
    marginBottom: 20,
  },

  buttonMainViewPersonalD_MDPI: {
    alignContent: 'center',
    flexDirection: 'column',
    marginBottom: 20,
    //marginTOp:0
  },

  buttonMainViewPersonalD_HDPI: {
    alignContent: 'center',
    flexDirection: 'column',
    marginBottom: 20,
    //marginTOp:0
  },
  buttonMainViewPersonalD_XHDPI: {
    alignContent: 'center',
    flexDirection: 'column',
    marginBottom: 20,
  },
  buttonMainViewPersonalD_XXHDPI: {
    alignContent: 'center',
    flexDirection: 'column',
    marginBottom: 20,
  },

  buttonTC1: {
    //marginRight:50
  },
  buttonTC2: {
    //marginRight:50
  },
  TCbtnstyle: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#B02A31',
    borderColor: 'white',
    borderRadius: 20,
    height: 40,
    width: 120,
  },
  btnTC1Text: {
    textAlign: 'center',
    padding: 5,
    fontFamily: 'Mulish, Helvetica Neue, Helvetica,Arial,sans-serif',
    color: 'white',
  },
  btnTC2Text: {
    textAlign: 'center',
    padding: 5,
    fontFamily: 'Mulish, Helvetica Neue, Helvetica,Arial,sans-serif',
    color: 'white',
  },
  btnTC3Text: {
    textAlign: 'center',
    padding: 5,
    fontFamily: 'Mulish, Helvetica Neue, Helvetica,Arial,sans-serif',
    color: 'white',
  },
  tcPdf1: {
    flexDirection: 'row',
    marginRight: 8,
  },
  tcPdf2: {
    flexDirection: 'row',
    marginRight: 8,
  },
  tcPdf3: {
    flexDirection: 'row',
    marginRight: 8,
  },
  buttonTC1: {
    marginRight: 5,
  },
  buttonTC2: {
    marginRight: 5,
  },
  buttonTC3: {
    marginRight: 5,
  },
  thankyouText: {
    fontFamily: 'Mulish',
    fontSize: 22,
    //textAlign:'center',
    //  marginBottom:10
    //marginTop:20
  },
  thankyouText2: {
    fontFamily: 'Mulish',
    fontSize: 16,
    //textAlign:'center',
    //  marginBottom:10
  },
  thankyouText3: {
    fontFamily: 'Mulish',
    fontSize: 16,
    //textAlign:'center',
    //  marginBottom:10
  },
  TimeView: {
    flexDirection: 'row',
  },
  outerButtonView: {
    flexDirection: 'row',
  },
  retailBtn: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'maroon',
    borderColor: 'black',
    // borderRadius: 20,
    height: 70,
    //width: 264,
    marginRight: 1,
  },
  retailBtnRed: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'grey',
    borderColor: 'black',
    // borderRadius: 20,
    height: 70,
    // width: 264,
    marginRight: 1,
  },
  capitalBtn: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'maroon',
    borderColor: 'black',
    // borderRadius: 20,
    height: 70,
    // width: 264,
    marginRight: 1,
  },
  capitalBtnRed: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'grey',
    borderColor: 'black',
    // borderRadius: 20,
    height: 70,
    // width: 264,
    marginRight: 1,
  },
  creditBtn: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'maroon',
    borderColor: 'black',
    // borderRadius: 20,
    height: 70,
    //   width: 263,
  },
  creditBtnRed: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'grey',
    borderColor: 'black',
    // borderRadius: 20,
    height: 70,
    //   width: 263,
  },
  TC: {
    fontFamily: 'Mulish, Helvetica Neue, Helvetica,Arial,sans-serif',
    fontSize: 16,
    color: 'black',
    marginLeft: 20,
    marginBottom: 30,
    marginTop: 10,
  },
  /*popup*/
  process: {
    marginTop: 0,
    bottom: Platform.OS === 'web' ? '5px' : null,
    alignItems: 'center',
    //  marginTop:0
  },
  processMain: {
    backgroundColor: '#B02A31',
    borderRadius: 20,
    height: 35,
    width: 150,
    marginBottom: 0,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },

  TYmaincontainer: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '66%',
    borderRadius: 10,
  },
  TYmaincontainer_LDPI: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '90%',
    borderRadius: 10,
    // marginTOp:0
  },
  TYmaincontainer_MDPI: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '90%',
    borderRadius: 10,
  },
  TYmaincontainer_HDPI: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '90%',
    borderRadius: 10,
    //  marginTop:0
  },

  TCPProductInfoMainView: {
    width: '50%',
    backgroundColor: 'white',
    justifyContent: 'center',
    alignSelf: 'center',
    borderColor: 'black',
    borderWidth: 1,
    // marginTOp:0
  },
  TCPProductInfoMainView_LDPI: {
    width: '100%',
    backgroundColor: 'white',
    justifyContent: 'center',
    alignSelf: 'center',
    borderColor: 'black',
    borderWidth: 1,
  },

  TCPProductInfoMainView_MDPI: {
    width: '100%',
    backgroundColor: 'white',
    justifyContent: 'center',
    alignSelf: 'center',
    borderColor: 'black',
    borderWidth: 1,
  },

  TCPProductInfoMainView_HDPI: {
    width: '100%',
    backgroundColor: 'white',
    justifyContent: 'center',
    alignSelf: 'center',
    borderColor: 'black',
    borderWidth: 1,
  },
  SLIuserinfoMain: {
    flexDirection: 'row',
    width: '100%',
  },
  SLIuserinfoMain_LDPI: {
    flexDirection: 'column',
    width: '100%',
  },
  SLIuserinfoMain_MDPI: {
    flexDirection: 'column',
    width: '100%',
  },
  SLIuserinfoMain_HDPI: {
    flexDirection: 'column',
    width: '100%',
  },
  ocrerr: {
    color: 'red',
    alignItems: 'center',
  },
  reviewLoan_Margin: {
    marginLeft: 10,
  },
  dealerQuote: {
    marginTop: 5,
    fontWeight: '700',
    marginBottom: 5,
    marginTop: 4,
    color: '#696969',
  },

  SLIuserinfoTwo: {
    flexDirection: 'column',
    flex: 2,
  },
  SLIuserinfoTwo_LDPI: {
    flexDirection: 'row',
    flex: 1,
  },
  SLIuserinfoTwo_MDPI: {
    flexDirection: 'row',
    flex: 1,
  },
  SLIuserinfoTwo_HDPI: {
    flexDirection: 'row',
    flex: 1,
  },
  SLIuserinfoEach: {
    flexDirection: 'column',
    flex: 1,
  },
  SLIuserinfoEach_LDPI: {
    flexDirection: 'row',
    flex: 1,
  },
  SLIuserinfoEach_MDPI: {
    flexDirection: 'row',
    flex: 1,
  },
  SLIuserinfoEach_HDPI: {
    flexDirection: 'row',
    flex: 1,
  },
  SLIuserinfoMainTextView: {
    width: '100%',
    marginBottom: 2,
    backgroundColor: '#f4f4ef',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10,
  },
  SLIuserinfoMainTextView_LDPI: {
    width: '100%',
    marginBottom: 2,
    backgroundColor: '#f4f4ef',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    padding: 10,
  },
  SLIuserinfoMainTextView_MDPI: {
    width: '100%',
    marginBottom: 2,
    backgroundColor: '#f4f4ef',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    padding: 10,
  },
  SLIuserinfoMainTextView_HDPI: {
    width: '100%',
    marginBottom: 2,
    backgroundColor: '#f4f4ef',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    padding: 10,
  },
  SLIuserinfoMainText: {
    fontSize: 18,

    fontFamily: 'Mulish',
  },
  SLIuserinfoMainText_LDPI: {
    fontSize: 14,
    textAlign: 'center',

    fontFamily: 'Mulish',
  },
  SLIuserinfoMainText_MDPI: {
    fontSize: 14,
    textAlign: 'center',

    fontFamily: 'Mulish',
  },
  SLIuserinfoMainText_HDPI: {
    fontSize: 14,
    textAlign: 'center',

    fontFamily: 'Mulish',
  },
  SLIuserinfoMainText_XHDPI: {
    fontSize: 16,

    textAlign: 'center',
    fontFamily: 'Mulish',
  },
  SLIuserinfoMainText_XXHDPI: {
    fontSize: 16,

    textAlign: 'center',
    fontFamily: 'Mulish',
  },
  SLIuserinfoSecondTextView: {
    width: '100%',
    backgroundColor: 'white',
    alignItems: 'center',
    justifyContent: 'center',
  },
  SLIuserinfoSecondTextView_LDPI: {
    width: '100%',
    backgroundColor: 'white',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  SLIuserinfoSecondTextView_MDPI: {
    width: '100%',
    backgroundColor: 'white',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  SLIuserinfoSecondTextView_HDPI: {
    width: '100%',
    backgroundColor: 'white',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  SLIuserinfoSecondTextView1: {
    width: '100%',
    backgroundColor: 'white',
    alignItems: 'center',
    justifyContent: 'center',
  },
  SLIuserinfoSecondTextView1_LDPI: {
    width: '100%',
    backgroundColor: 'white',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  SLIuserinfoSecondTextView1_MDPI: {
    width: '100%',
    backgroundColor: 'white',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    borderTopColor: '#d7d7cf',
    borderTopWidth: 1,
  },
  SLIuserinfoSecondTextView1_HDPI: {
    width: '100%',
    backgroundColor: 'white',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  SLIBtnMainView: {
    backgroundColor: '#fff',
    alignItems: 'center',
    marginTop: 10,
    justifyContent: 'center',
    marginBottom: 30,
  },
  SLIDeliveryBtnStyle: {
    margin: 10,
    borderRadius: 0,
    backgroundColor: '#0c4678',
    padding: 12,
    paddingLeft: 50,
    paddingRight: 50,
  },
  SLIDeliveryBtnStyle_LDPI: {
    margin: 10,
    borderRadius: 0,
    backgroundColor: '#0c4678',
    padding: 12,
    paddingLeft: 12,
    paddingRight: 12,
  },
  SLIDeliveryBtnStyle_MDPI: {
    margin: 10,
    borderRadius: 0,
    backgroundColor: '#0c4678',
    padding: 12,
    paddingLeft: 20,
    paddingRight: 20,
  },
  SLIDeliveryBtnStyle_HDPI: {
    margin: 10,
    borderRadius: 0,
    backgroundColor: '#0c4678',
    padding: 12,
    paddingLeft: 20,
    paddingRight: 20,
  },
  SLIDeliveryBtnTextStyle: {
    color: '#fff',
    fontWeight: '600',
    fontFamily: 'Mulish',
    fontSize: 16,
  },
  SLIDeliveryBtnTextStyle_LDPI: {
    color: '#fff',
    fontWeight: '600',
    fontFamily: 'Mulish',
    fontSize: 14,
    textAlign: 'center',
  },
  SLIDeliveryBtnTextStyle_MDPI: {
    color: '#fff',
    fontWeight: '600',
    fontFamily: 'Mulish',
    fontSize: 14,
    textAlign: 'center',
  },
  SLIDeliveryBtnTextStyle_HDPI: {
    color: '#fff',
    fontWeight: '600',
    fontFamily: 'Mulish',
    fontSize: 14,
  },
  ADTextInputFieldStyleOrgDetailsNRI: {
    width: '100%',
    // marginLeft: 10,
    // height: 30,
    color: 'black',
    borderColor: 'transparent',
    borderBottomColor: '#dadada',
    borderWidth: 0.5,
    paddingTop: 10,
    paddingBottom: 10,
    marginLeft: 10,
  },
  ADTextInputFieldStyleOrgDetailsNRIFATCA: {
    width: '100%',
    // marginLeft: 10,
    // height: 30,
    color: 'black',
    borderColor: 'transparent',
    borderBottomColor: '#dadada',
    borderWidth: 0.5,
    paddingTop: 10,
    // paddingBottom: 10,
    // marginLeft: 10,
  },

  stopwatchStyle: { justifyContent: 'center', marginRight: '5%' },
  stopwatchStyle_XHDPI: { justifyContent: 'center', marginRight: '1%' },
  stopwatchStyle_HDPI: { justifyContent: 'center', marginRight: '1%' },
  stopwatchStyle_MDPI: { justifyContent: 'center', marginRight: '1%' },
  stopwatchStyle_LDPI: { justifyContent: 'center', marginRight: '1%' },
  MobileinputView3nri_New: {
    alignItems: 'center',
    justifyContent: 'center',
    borderBottomColor: 'rgb(218, 218, 218)',
    borderBottomWidth: 0.5,
    width: '50%',
  },

  /**insta nri facta details */
  subcontainer_Facta: {
    width: '100%',
    marginTop: 20,
  },
  subcontainer_Facta_LDPI: {
    width: '100%',
    marginTop: 30,
  },
  subcontainer_Facta_MDPI: {
    width: '100%',
    marginTop: 30,
  },

  maincontainer_facta: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '100%',
    borderRadius: 10,
  },
  maincontainer_facta_LDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    borderRadius: 8,
  },
  maincontainer_facta_MDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    borderRadius: 8,
  },
  maincontainer_facta_HDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    borderRadius: 8,
  },
  maincontainer_facta_XHDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    borderRadius: 8,
  },
  switch_container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  text_no: {
    display: 'flex',
    marginRight: 5,
    fontFamily: 'Mulish, Helvetica Neue, Helvetica,Arial,sans-serif',
    alignItems: 'center',
  },
  text_yes: {
    display: 'flex',
    marginLeft: 5,
    fontFamily: 'Mulish, Helvetica Neue, Helvetica,Arial,sans-serif',
    alignItems: 'center',
  },
  overseasMainButton: {
    flexDirection: 'row',
    alignSelf: 'center',
    marginTop: 20,
    marginBottom: 40,
  },
  overseasMainBtn: {
    flexDirection: 'row',
    alignSelf: 'center',
    marginTop: 20,
  },
  communicationBtn: {
    marginTop: 10,
    marginLeft: 5,
    color: 'red',
  },
  overseasBackBtn: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'maroon',
    borderColor: 'black',
    borderRadius: 10,
    height: 35,
    width: 100,
    marginRight: 1,
  },
  NDinnerContainerItemParental: {
    margin: 20,
    marginTop: 10,
  },

  PD_btnmobiletext: {
    fontSize: 12,
    color: '#696969',
    fontWeight: '500',
    textAlign: 'center',
    color: '#fff',
    marginTop: 10,
  },
  PD_btnMobile: {
    backgroundColor: 'rgb(176, 42, 49)',
    borderColor: '#fff',
    borderRadius: 20,
    height: 35,
    width: 150,
    marginBottom: 15,
  },

  NDmainContainerDD: {
    backgroundColor: 'white',
    //  zIndex: -9,
    alignSelf: 'center',
    width: '70%',
    borderRadius: 10,
  },
  NDmainContainerDD_LDPI: {
    backgroundColor: 'white',
    //  zIndex: -9,
    alignSelf: 'center',
    width: '95%',
    borderRadius: 10,
  },
  NDmainContainerDD_MDPI: {
    backgroundColor: 'white',
    //  zIndex: -9,
    alignSelf: 'center',
    width: '95%',
    borderRadius: 10,
  },
  NDmainContainerDD_HDPI: {
    backgroundColor: 'white',
    //  zIndex: -9,
    alignSelf: 'center',
    width: '95%',
    borderRadius: 10,
  },

  DirectorPageMarginleft: {
    marginLeft: 35,
  },
  DirectorPageMarginleft_LDPI: {
    marginLeft: 0,
  },
  DirectorPageMarginleft_MDPI: {
    marginLeft: 0,
  },
  DirectorPageMarginleft_HDPI: {
    marginLeft: 0,
  },
  RCinputsheadingAuthorisedSignatoryText: {
    fontSize: 16,
    fontWeight: '700',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    marginTop: 10,
  },
  RCinputsheadingAuthorisedSignatoryText_LDPI: {
    fontSize: 16,
    fontWeight: '700',
    width: '95%',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    marginTop: 10,
  },
  RCinputsheadingAuthorisedSignatoryText_MDPI: {
    fontSize: 16,
    width: '95%',
    fontWeight: '700',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    marginTop: 10,
  },
  RCeditBtnViewAuthorisedSignatoryText: {
    position: 'absolute',
    top: 0,
    right: 20,
  },
  RCeditBtnViewAuthorisedSignatoryText_LDPI: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  RCeditBtnViewAuthorisedSignatoryText_MDPI: {
    position: 'absolute',
    top: 0,
    right: 0,
  },

  Currentaccount_Directorstyle: {
    flexDirection: 'row',
  },
  Currentaccount_Directorstyle_LDPI: {
    flexDirection: 'column',
  },
  Currentaccount_Directorstyle_HDPI: {
    flexDirection: 'column',
  },
  Currentaccount_Directorstyle_MDPI: {
    flexDirection: 'column',
  },
  Currentaccount_Directorstyle2: {
    marginLeft: 100,
  },
  Currentaccount_Directorstyle2_LDPI: {
    marginLeft: 0,
    marginTop: 20,
  },
  Currentaccount_Directorstyle2_MDPI: {
    marginLeft: 0,
    marginTop: 20,
  },
  Currentaccount_Directorstyle2_HDPI: {
    marginLeft: 0,
    marginTop: 20,
  },
  KnowMoreheading: {
    color: 'black',
    marginLeft: 10,
    fontWeight: '400',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontSize: 18,
    marginBottom: 20,

  },
  spacingKnowMore: {
    marginBottom: 3,

  },
  messageStyle: {
    marginLeft: 28,
    fontSize: 14,
    color: 'red',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  /*nri upload popup*/
  uploadLeftRight: {
    width: '46%',
    borderWidth: 1,
    marginLeft: '2%',
    marginRight: '2%',
    borderColor: 'grey',
  },
  uploadMainImgSection: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
  },
  upldText: {
    backgroundColor: '#B02A31',
    //borderRadius: 20,
    //height: 35,
    width: '100%',
    marginBottom: 0,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    paddingTop: '5%',
    paddingBottom: '5%',
    textTransform: 'uppercase',
  },
  errMsgpassport: {
    marginTop: 10,
  },
  coapplicant: {
    marginLeft: 20,
    fontSize: 16,
    marginTop: 10,
  },
  coapplicantView: {
    marginTop: 20,
    marginLeft: 10,
  },
  PDContBtnView: {
    marginTop: 30,
    marginLeft: 20,
    marginLeft: 25,
  },
  PD_btnMobile: {
    backgroundColor: 'rgb(176, 42, 49)',
    borderColor: '#fff',
    borderRadius: 20,
    height: 35,
    width: 150,
    marginBottom: 15,
  },
  PD_btnmobiletext: {
    fontSize: 12,
    color: '#696969',
    fontWeight: '500',
    textAlign: 'center',
    color: '#fff',
    marginTop: 10,
  },
  // EMI Calculator
  EMImaincontainer: {
    backgroundColor: 'white',
    zIndex: -9,
    alignSelf: 'center',
    width: '90%',
    borderRadius: 10,
    marginTop: 30,
  },
  EMImaincontainer_LDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    borderRadius: 8,
  },
  EMImaincontainer_MDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    borderRadius: 8,
  },
  EMImaincontainer_HDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    borderRadius: 8,
  },
  EMImaincontainer_XHDPI: {
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    borderRadius: 8,
  },
  Emisubcontainer: {
    width: "100%",
  },
  jewelleryInputView: {
    width: '19%',
    marginBottom: 15,
    marginRight: 6,
    marginTop: 10
  },
  jewelleryInputView_LDPI: {
    width: '100%',
    marginBottom: 15,
    marginRight: 10
  },
  jewelleryInputView_MDPI: {
    width: '100%',
    marginBottom: 15,
    marginRight: 10
  },
  jewelleryInputView_HDPI: {
    width: '100%',
    marginBottom: 15,
    marginRight: 10
  },
  jewelleryInputView_XHDPI: {
    width: '100%',
    marginBottom: 15,
    marginRight: 10
  },
  jewelleryInputView_XXHDPI: {
    width: '100%',
    marginBottom: 15,
    marginRight: 10
  },
  jewelleryInputView_XXXHDPI: {
    width: '100%',
    marginBottom: 15,
    marginRight: 10
  },
  jewelleryDrpView: {
    zIndex: 9999,
    width: '13%',
    marginRight: 10,
    marginTop: 10,
  },
  jewelleryDrpView_LDPI: {
    zIndex: 9999,
    // marginBottom:15,
    width: '100%',
    marginRight: 10
  },
  jewelleryDrpView_MDPI: {
    zIndex: 9999,
    //marginBottom:15,
    width: '100%',
  },
  jewelleryDrpView_HDPI: {
    zIndex: 9999,
    // marginBottom:15,
    width: '100%',
    marginRight: 10,
  },
  jewelleryDrpView_XHDPI: {
    zIndex: 9999,
    // marginBottom:15,
    width: '100%',
    marginRight: 10
  },
  jewelleryDrpView_XXHDPI: {
    zIndex: 9999,
    //marginBottom:15,
    width: '100%',
    marginRight: 10
  },
  jewelleryDrpView_XXXHDPI: {
    zIndex: 9999,
    // marginBottom:15,
    width: '100%',
    marginRight: 10
  },
  jewelleryImageView: {
    position: 'relative',
    width: '23%',
    marginRight: 10,
    marginTop: 10
  },
  jewelleryImageView_LDPI: {
    flexDirection: 'row',
    position: 'relative',
    bottom: 10,
    marginTop: 19,
    marginBottom: 15,
    width: '100%',
    marginRight: 0
  },
  jewelleryImageView_MDPI: {
    flexDirection: 'row',
    position: 'relative',
    bottom: 10,
    marginTop: 19,
    marginBottom: 15,
    width: '100%',
    marginRight: 0
  },
  jewelleryImageView_HDPI: {
    flexDirection: 'row',
    position: 'relative',
    bottom: 10,
    marginTop: 19,
    marginBottom: 15,
    width: '100%',
    marginRight: 0
  },
  jewelleryImageView_XHDPI: {
    flexDirection: 'row',
    position: 'relative',
    bottom: 10,
    marginTop: 19,
    marginBottom: 15,
    width: '100%',
    marginRight: 0
  },
  jewelleryImageView_XHDPI: {
    flexDirection: 'row',
    position: 'relative',
    bottom: 10,
    marginTop: 19,
    marginBottom: 15,
    width: '100%',
  },
  jewelleryImageView_XXHDPI: {
    flexDirection: 'row',
    position: 'relative',
    bottom: 10,
    marginTop: 19,
    marginBottom: 15,
    width: '100%',
    marginRight: 0
  },
  jewelleryImageView_XXXHDPI: {
    flexDirection: 'row',
    position: 'relative',
    bottom: 10,
    marginTop: 19,
    marginBottom: 15,
    width: '100%',
    marginRight: 0
  },
  imageUploadView:
  {
    //  alignSelf:'center'
    marginLeft: 60
  },
  imageUploaded:
  {
    width: 20,
    height: 20,
  },
  addStyle:
  {
    width: 15,
    height: 15,
  },
  minusStyle:
  {
    width: 15,
    height: 15,
  },
  upload:
  {
    width: 40,
    height: 40,
  },
  hyperlink: {
    color: '#EE731B'
  },
  nextIndex: {
    zIndex: -9
  },
  Detailspopupcontainer: {
    position: Platform.OS === 'web' ? 'fixed' : 'absolute',
    minHeight: 'auto',
    zIndex: 9,
    marginLeft: 'auto',
    marginRight: 'auto',
    left: 0,
    right: 0,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    borderColor: 'transparent',
    borderWidth: 1,
  },
  MobilePopupbootboxMainbox: {
    backgroundColor: 'white',
    width: '80%',
    borderWidth: 0.5,
    borderRadius: 0,
    marginTop: 10,
    zIndex: 9,
  },
  MobilePopupbootboxMainboxATM: {
    backgroundColor: 'white',
    borderWidth: 0.5,
    borderRadius: 0,
    marginTop: 10,
    overflowY: 'scroll',
    width: '93%',
    height: '69%',
    zIndex: 9
  },
  MobilePopupbootboxMainbox_LAPTOP: {
    width: '50%',
  },
  MobilePopupbootboxMainbox_LDPI: {
    marginTop: '33%',
    margin: 'auto',
    width: '96%',
  },
  MobilePopupbootboxMainbox_MDPI: {
    marginTop: 'auto',
    margin: 'auto',
    width: '93%',
  },
  MobilePopupbootboxMainbox_HDPI: {
    marginTop: 'auto',
    margin: 'auto',
    width: '90%',
  },
  Detailspopupbtn: {
    borderRadius: 20,
    alignSelf: 'flex-end',
    marginTop: 10,
    marginRight: 15,
  },
  DetailspopupbtnText: {
    fontSize: 16,
    fontWeight: '500',
    textAlign: 'center',
    color: 'grey',
  },
  Detailspopuptext: {
    fontSize: 17,
    lineHeight: 27,
    color: '#333',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontWeight: 'bold'
  },
  Detailspopuptext_MDPI: {
    fontSize: 12,
    lineHeight: 25,
    color: '#333',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontWeight: 'bold'
  },
  Detailspopuptext_LDPI: {
    fontSize: 12,
    lineHeight: 25,
    color: '#333',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontWeight: 'bold'
  },
  Detailspopuptext_HDPI: {
    fontSize: 12,
    lineHeight: 25,
    color: '#333',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
    fontWeight: 'bold'
  },
  MobilePopupbootboxtextView: {
    display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'center',
    flexDirection: 'column',
    padding: 20
  },
  MobilePopupbootboxtextView_LDPI: {
    display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'center',
    flexDirection: 'column',
    paddingVertical: 15
  },
  Detailspopuptextvalue: {
    fontSize: 17,
    lineHeight: 27,
    color: '#333',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  Detailspopuptextvalue_MDPI: {
    fontSize: 12,
    lineHeight: 25,
    color: '#333',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  Detailspopuptextvalue_LDPI: {
    fontSize: 12,
    lineHeight: 25,
    color: '#333',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  },
  Detailspopuptextvalue_HDPI: {
    fontSize: 12,
    lineHeight: 25,
    color: '#333',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
  }
});
